import React, { useEffect, useState, useRef } from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Echo from "laravel-echo";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CreditCheck from "../../components/Booking/CreditCheck";
import {
    faFilePen,
    faFileInvoice,
    faGear,
    faCreditCard,
    faPersonWalkingDashedLineArrowRight,
    faRobot,
    faPeople,
    faScanner,
    faScannerKeyboard,
    faTrash,
    faClipboardList,
} from "@fortawesome/pro-solid-svg-icons";
import {
    faEnvelopesBulk,
    faFilter,
    faLock,
    faSpinnerThird,
    faUsersRectangle,
    faWifi,
    faUser,
    faChartNetwork,
    faPlus,
    faFingerprint,
    faHandHoldingDollar,
    faUserGroup,
    faBuilding,
    faCalendarCheck,
    faHousePersonReturn,
    faListCheck,
    faBagShopping,
    faRectangleHistory,
    faCamera,
    faChartLine,
    faMapPin,
    faPhone,
    faExclamationTriangle,
} from "@fortawesome/pro-regular-svg-icons";
import { Disclosure, Transition } from "@headlessui/react";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { openModal } from "../../store/modal/modalReducer";
import ErrorBoundary from "../../containers/ErrorBoundary";
import NotificationToast from "../../components/Helpers/NotificationToast";
import { getBooking } from "../../store/booking/bookingActions";
import AppLoader from "../../components/Helpers/AppLoader";
import BookingForm from "../../components/Booking/BookingForm";
import GridSaveInformation from "../../components/Booking/GridSaveInformation";
import BookingList from "../../components/Booking/BookingList";
import BookingMessages from "../../components/Booking/BookingMessages";
import LoadingIcon from "../../components/Helpers/LoadingIcon";
import CustomButton from "../../components/Helpers/CustomButton";
import BookingButtons from "../../components/Booking/BookingButtons";
import GridInvoiceInformation from "../../components/Booking/GridInvoiceInformation";
import GridBookingInformation from "../../components/Booking/GridBookingInformation";
import GridPayments from "../../components/Booking/GridPayments";
import GridAdditionalInvoice from "../../components/Booking/GridAdditionalInvoice";
import GridMoveIn from "../../components/Booking/GridMoveIn";
import AtInfo from "../../components/Booking/AtInfo";
import GridSettings from "../../components/Booking/GridSettings";
import GridBookingAppointments from "../../components/Booking/GridBookingAppointments";
import CustomOrders from "../../components/Booking/CustomOrders";
import GridBiometrics from "../../components/Booking/GridBiometrics";
import QueuePlate from "../../components/Booking/QueuePlate";
import GridAOS from "../../components/Booking/GridAOS";
import BookingBotFlow from "../../components/Booking/BotFlow";
import LinkedChats from "../../components/Booking/LinkedChats";
import LinkedChatsBar from "../../components/Booking/LinkedChatsBar";
import GridBookingMda from "../../components/Booking/GridBookingMda";
import GridDocumentGeneration from "../../components/Booking/GridDocumentGeneration";
import BiometricsPanel from "../../components/Booking/BiometricsPanel";
import WeekendPassPanel from "../../components/Booking/WeekendPassPanel";
import CreditCheckQueue from "../../components/Booking/CreditCheckQueue";
import RogersStuff from "../../components/Booking/RogersStuff";
import CancellationsModal from "../../components/Booking/CancellationsModal";
import MonthendDashboardModal from "../../components/Monthend/MonthendDashboardModal";
import SnagCode from "../../components/Booking/SnagCode";
import GridLeadSources from "../../components/Booking/GridLeadSources";
import PropertyInterestIndicator from "../../components/Booking/PropertyInterestIndicator";

// Sanitize channel name to match backend Pusher channel naming
// Pusher only allows: a-z, A-Z, 0-9, _, -, =, @, ,, ., ;
const sanitizeChannelName = (channel) => {
    return channel.replace(/[^a-zA-Z0-9_\-=@,.;]/g, "-");
};

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const getDaysSinceScan = (scanDate) => {
    if (!scanDate) return null;
    const today = new Date();
    const scan = new Date(scanDate);
    const diffTime = Math.abs(today - scan);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};

const getScanIconColor = (days) => {
    if (days === null || days >= 3) return "text-red-500";
    return "text-green-500";
};

const formatScanDate = (scanDate) => {
    if (!scanDate) return "No scan recorded";
    return new Date(scanDate).toLocaleString();
};

export default function BookingGrid(props) {
    const dispatch = useDispatch();

    const { type } = useParams();

    const { current_staff, staff, permissions } = useSelector((state) => state.auth);
    const { current_booking, flagged_ids } = useSelector((state) => state.booking);
    const { tags } = useSelector((state) => state.tags);
    const { folders } = useSelector((state) => state.folders);
    const { settings } = useSelector((state) => state.settings);

    const [messages, setMessages] = useState([]);
    const [messagesPagination, setMessagesPagination] = useState({ total: 0, limit: 1000, offset: 0, has_more: false });
    const [loadingOlderMessages, setLoadingOlderMessages] = useState(false);
    const [bookings, setBookings] = useState([]);
    const [filterCount, setFilterCount] = useState(0);
    const [allBookings, setAllBookings] = useState([]);
    const [historicBookings, setHistoricBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [messageLoading, setMessageLoading] = useState(false);
    const [mdaLoadingT, setMdaLoadingT] = useState(false);
    const [mdaLoadingL, setMdaLoadingL] = useState(false);

    // const [assignedFilter, setAssignedFilter] = useState("mine");
    const [sortFilter, setSortFilter] = useState(() => {
        const saved = localStorage.getItem('bookingSortGlobal');
        return saved || "asc";
    });
    const [filterLocation, setFilterLocation] = useState({ id: 0, name: "" });
    const [filterGender, setFilterGender] = useState({ id: 0, name: "" });
    const [filterFunding, setFilterFunding] = useState({ id: 0, name: "" });
    const [filterLocationChange, setFilterLocationChange] = useState({ id: 0, name: "" });
    const [filterDocuments, setFilterDocuments] = useState({ id: 0, name: "" });
    const [filterStudyYear, setFilterStudyYear] = useState({ id: 0, name: "" });
    const [filterUnitType, setFilterUnitType] = useState({ id: 0, name: "" });
    const [filterBookingSummary, setFilterBookingSummary] = useState({ id: 0, name: "" });
    const [filterBudget, setFilterBudget] = useState({ id: 0, name: "" });
    const [filterBotFlow, setFilterBotFlow] = useState({ id: 0, name: "" });
    const [filterBalance, setFilterBalance] = useState({ id: 0, name: "" });

    const [filterVendor, setFilterVendor] = useState({ id: 0, name: "" });
    const [filterStatus, setFilterStatus] = useState({ id: 0, name: "" });
    const [filterAppointment, setFilterAppointment] = useState({ id: 0, name: "" });
    const [filterRenewalChoice, setFilterRenewalChoice] = useState({ id: 0, name: "" });
    const [filterTenantType, setFilterTenantType] = useState({ id: 0, name: "" });

    const { properties } = useSelector((state) => state.properties);
    const { collections } = useSelector((state) => state.collections);

    const [allowClick, setAllowClick] = useState(true);
    const [firstSearch, setFirstSearch] = useState(true);

    const [showManualLink, setShowManualLink] = useState(false);
    const [mdaBalance, setMdaBalance] = useState(null);

    const [doSub, setDoSub] = useState("");
    const [doSubTag, setDoSubTag] = useState("");
    const [doSubMention, setDoSubMention] = useState("");
    const [sortDir, setSortDir] = useState("asc");
    const [showNewMessages, setShowNewMessages] = useState(false);
    const [oldBooking, setOldBooking] = useState(0);

    const [chatsLoading, setChatsLoading] = useState(false);
    const [chatsMsgLoading, setChatsMsgLoading] = useState(false);

    const [ignoreRefresh, setIgnoreRefresh] = useState(false);

    // Twilio Call Modal state
    const [showCallModal, setShowCallModal] = useState(false);
    const [agentCell, setAgentCell] = useState("");
    const [callLoading, setCallLoading] = useState(false);

    const [wiFiLoading, setWiFiLoading] = useState(false);
    const [wiFiLoading2, setWiFiLoading2] = useState(false);
    const [wifiUsername, setWifiUsername] = useState("");
    const [wifiPassword, setWifiPassword] = useState("");
    const [linkedChats, setLinkedChats] = useState([]);
    // Unit-mates (bookings sharing the same unit), used by the linked-chats bar on
    // QL/QP only. UC's bar uses linkedChats (directly-linked chats) instead.
    const [unitChats, setUnitChats] = useState([]);
    const isUC = process.env.REACT_APP_COLOUR === "UC";
    const [linkedLoading, setLinkedLoading] = useState(false);
    const [lookups, setLookups] = useState([]);
    const [mdaBalanceLoading, setMdaBalanceLoading] = useState(false);
    const [showMemoryWarning, setShowMemoryWarning] = useState(false);
    // Custom Data tab state
    const [customData, setCustomData] = useState([]);
    const [customDataLoading, setCustomDataLoading] = useState(false);
    const [customSearch, setCustomSearch] = useState("");
    const [newCustomKey, setNewCustomKey] = useState("");
    const [newCustomValue, setNewCustomValue] = useState("");
    const [customSubmitting, setCustomSubmitting] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [editingCustomId, setEditingCustomId] = useState(null);
    const [editCustomKey, setEditCustomKey] = useState("");
    const [editCustomValue, setEditCustomValue] = useState("");
    const [editCustomSubmitting, setEditCustomSubmitting] = useState(false);
    const [showDashboard, setShowDashboard] = useState(false);
    const [showCancellationsModal, setShowCancellationsModal] = useState(false);

    // Check if current folder is the cancellations folder
    const isCancellationsFolder = () => {
        const cancellationsFolderId = settings?.cancellations_folder_id;
        if (!cancellationsFolderId) return type === 'cancellations'; // Fallback to name check
        
        const currentFolder = folders?.find(f =>
            f.name.toLowerCase().replace(/\s+/g, '') === type.toLowerCase() ||
            f.href === type
        );
        
        return currentFolder?.id === cancellationsFolderId;
    };

    // Check if current folder is the renewal folder
    const isRenewalsFolder = () => {
        const renewalsFolderId = settings?.monthend_renew_folder_id;
        if (!renewalsFolderId) return type === 'renewals'; // Fallback to name check
        
        const currentFolder = folders?.find(f =>
            f.name.toLowerCase().replace(/\s+/g, '') === type.toLowerCase() ||
            f.href === type
        );
        
        return currentFolder?.id === renewalsFolderId;
    };

    // Check if current folder supports month-end dashboard
    const isMonthendFolder = () => {
        return isCancellationsFolder() || isRenewalsFolder();
    };

    // Get folder type for dashboard
    const getMonthendFolderType = () => {
        if (isCancellationsFolder()) return 'cancellations';
        if (isRenewalsFolder()) return 'renewals';
        return null;
    };

    // Check if current booking is tenant-only (not lease holder)
    const isTenantOnly = () => {
        return current_booking?.tenant_type === 'TN';
    };

    // Helper to fetch custom data for current user
    const copyToClipboard = (text) => {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                toast(<NotificationToast title="Copied!" message="Booking reference copied to clipboard" type="success" />);
            })
            .catch((err) => {
                toast(<NotificationToast title="Copy Failed" message="Could not copy to clipboard" type="error" />);
            });
    };

    const fetchCustomData = async () => {
        if (!current_booking?.user?.id) return;
        setCustomDataLoading(true);
        try {
            const resp = await axios.get(`${process.env.REACT_APP_API_URL}user/${current_booking.user.id}/custom-data`);
            setCustomData(Array.isArray(resp.data) ? resp.data : []);
        } catch (e) {
            toast(<NotificationToast title="Failed to load Custom Data" message={e?.response?.data?.message || e?.message || "Unknown error"} type="error" />);
        } finally {
            setCustomDataLoading(false);
        }
    };

    const location = useLocation();

    const [msgCount, setMsgCount] = useState(25);

    const genderOptions = [
        { value: 1, label: "Male" },
        { value: 2, label: "Female" },
    ];

    // Open call modal and default agent cell from current_staff if available
    function openCallModal() {
        let defaultCell = "";
        if (current_staff && current_staff.cell) {
            defaultCell = current_staff.cell.toString();
            if (defaultCell && defaultCell.charAt(0) !== "+") {
                defaultCell = "+" + defaultCell;
            }
        }
        setAgentCell(defaultCell);
        setShowCallModal(true);
    }

    async function initiateCall() {
        if (!agentCell) {
            toast(<NotificationToast title="Agent cell required" message="Please enter your cell number to initiate the call." type="error" />);
            return;
        }
        setCallLoading(true);
        try {
            const payload = {
                agent_cell: agentCell,
                applicant_cell: current_booking?.user?.cell,
                current_booking,
                current_staff,
            };
            const resp = await axios.post(`${process.env.REACT_APP_API_URL}twilio/call`, payload);
            if (resp.data && resp.data.success) {
                toast(<NotificationToast title="Calling started" message={`We are calling ${agentCell} and will bridge to ${current_booking?.user?.cell}.`} />);
                setShowCallModal(false);
            } else {
                toast(<NotificationToast title="Call failed" message={resp.data?.message || "Unable to initiate the call."} type="error" />);
            }
        } catch (e) {
            toast(<NotificationToast title="Call failed" message={e?.response?.data?.message || e?.message || "Unable to initiate the call."} type="error" />);
        } finally {
            setCallLoading(false);
        }
    }

    const fundingOptions = [
        { label: "NSFAS UJ", value: 4 },
        { label: "NSFAS WITS", value: 5 },
        // { label: "NSFAS CJC", value: 6 },
        { label: "NSFAS TVET", value: 1 },
        { label: "NSFAS NDT", value: 8 },
        { label: "Bursary", value: 2 },
        { label: "Private", value: 3 },
    ];

    const handleHistoricBookingsCallback = (childData) => {
        setHistoricBookings(childData);
    };

    var url_string = window.location.href;

    var url = new URL(url_string);
    var tag_id = url.searchParams.get("tag");
    var collection_tag_id = url.searchParams.get("collection_tag");
    var user_id = url.searchParams.get("user_id");
    var active_booking_id = url.searchParams.get("booking_id");
    var property_id = url.searchParams.get("property_id");
    var openCancellations = url.searchParams.get("opencancellations");
    var pathnameLocation = url.pathname.split("/").pop();

    // If we're on an archived route and no tag_id is set, check the URL path for the tag ID
    if (type === "archived" && !tag_id && pathnameLocation && pathnameLocation !== "archived") {
        tag_id = pathnameLocation;
        console.log("Using archived tag ID from URL path:", tag_id);
    }

    // console.log('URL Parameters:', {
    //     pathname: url.pathname,
    //     type,
    //     tag_id,
    //     collection_tag_id,
    //     user_id,
    //     active_booking_id,
    //     pathnameLocation
    // });

    useEffect(async () => {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}uc_lookups`,
        })
            .then((response) => {
                setLookups(response.data);
            })
            .catch((error) => {
                // alert("lookups failed");
            });
    }, []);

    // Persist sort preference globally across all folders
    useEffect(() => {
        localStorage.setItem('bookingSortGlobal', sortFilter);
    }, [sortFilter]);

    // Function to load older messages with pagination
    const loadOlderMessages = async () => {
        if (!current_booking || loadingOlderMessages || !messagesPagination.has_more) return;
        
        setLoadingOlderMessages(true);
        const newOffset = messagesPagination.offset + messagesPagination.limit;
        
        try {
            const response = await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}get_booking_messages`,
                data: { 
                    booking_id: current_booking.id,
                    offset: newOffset,
                    limit: messagesPagination.limit
                },
            });
            
            const data = Array.isArray(response.data) ? response.data : response.data.messages;
            const array = [];
            
            // Update pagination metadata
            if (!Array.isArray(response.data)) {
                setMessagesPagination({
                    total: response.data.total || 0,
                    limit: response.data.limit || 1000,
                    offset: response.data.offset || 0,
                    has_more: response.data.has_more || false
                });
            }
            
            Object.keys(data).forEach((key) => {
                if (data[key].files !== null) {
                    data[key].files = data[key].files.split(",");
                } else {
                    data[key].files = [];
                }
                
                data[key].timestamp = format(new Date(data[key].created_at), "dd MMM yyyy HH:mm:ss");
                data[key].from = parseInt(data[key].from);
                data[key].to = parseInt(data[key].to);
                array.push(data[key]);
            });
            
            // Prepend older messages to existing messages
            setMessages((prevMessages) => [...array, ...prevMessages]);
        } catch (error) {
            console.error("Error loading older messages:", error);
        } finally {
            setLoadingOlderMessages(false);
        }
    };

    const prevTagIdRef = useRef();

    useEffect(async () => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;

        let echo;

        if (process.env.REACT_APP_REVERB_APP_ID) {
            echo = new Echo({
                broadcaster: "reverb", // Change "pusher" to "reverb"
                key: process.env.REACT_APP_REVERB_APP_KEY,
                wsHost: process.env.REACT_APP_REVERB_URL,
                wssHost: process.env.REACT_APP_REVERB_URL,
                wsPort: process.env.REACT_APP_REVERB_PORT,
                wssPort: process.env.REACT_APP_REVERB_PORT,
                disableStats: true,
                encrypted: process.env.REACT_APP_REVERB_SCHEME === "https",
                forceTLS: process.env.REACT_APP_REVERB_SCHEME === "https",
                enableLogging: true,
            });
        } else {
            echo = new Echo({
                broadcaster: "pusher",
                key: process.env.REACT_APP_MIX_ABLY_PUBLIC_KEY,

                wsHost: process.env.REACT_APP_MIX_ABLY_URL,
                wssHost: process.env.REACT_APP_MIX_ABLY_URL,

                wsPort: process.env.REACT_APP_MIX_ABLY_PORT,
                wssPort: process.env.REACT_APP_MIX_ABLY_PORT,

                disableStats: true,
                encrypted: false,
                enabledTransports: ["ws", "wss"],
                forceTLS: false,

                enableLogging: true,

                // unavailableTimeout: 1000,
                // activityTimeout: 1000,
                // pongTimeout: 2000,
            });
        }

        const forceRefresh = prevTagIdRef.current !== tag_id || props.history.action === "PUSH";

        // Update the previous tag ID ref
        prevTagIdRef.current = tag_id;

        // console.log("Checking fetch conditions:", {
        //     doSub,
        //     type,
        //     doSubTag,
        //     tag_id,
        //     forceRefresh,
        //     historyState: props.history.location.state,
        //     messageLoading,
        //     currentPath: window.location.pathname + window.location.search,
        // });

        if (
            doSub === "" ||
            doSub !== type ||
            doSubTag !== tag_id ||
            forceRefresh ||
            (props.history.location.state !== undefined && props.history.location.state?.from !== undefined) ||
            messageLoading === true
        ) {
            // console.log("Fetch conditions met, proceeding with data fetch");
            // Always clear bookings when tag changes to show loading state
            setBookings([]);
            setChatsLoading(true);

            // Clean up any existing Echo channels
            Object.keys(echo.connector.channels).forEach((channel) => {
                if (channel.startsWith("TagMessages.") || channel.startsWith("Messages.")) {
                    echo.leave(channel);
                }
            });

            if ((type === "management" || type === "general" || type === "loading" || type === "vacating" || type === "archived") && tag_id !== null && tag_id !== undefined) {
                if (messageLoading === false) {
                    setChatsLoading(true);
                }
                setLoading(false);
                setDoSub(type);
                setDoSubTag(tag_id);

                // Replace the event-based loading with direct API call
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}get_management_bookings/${type}/${tag_id}${property_id ? `?property_id=${property_id}` : ''}`,
                }).then((response) => {
                    const array = [];
                    Object.keys(response.data).forEach((key) => {
                        array.push(response.data[key]);
                    });

                    if (sortFilter === "asc") {
                        array.sort((a, b) => (a.n > b.n ? -1 : 1));
                    } else {
                        array.sort((a, b) => (a.n > b.n ? 1 : -1));
                    }

                    setBookings(array);
                    setChatsLoading(false);
                });

                // Keep the Echo channel for real-time updates
                echo.channel(`TagMessages.${tag_id}`)
                    .subscribed(() => {
                        // console.log("You are subscribed Message List Tags");
                    })
                    .listen("TagBookingsEvent", (data) => {
                        if (data[1] === window.location.href.split("/").pop().split("=")[1].split("&")[0]) {
                            // Check if payload was too large - if so, do nothing to avoid disrupting user
                            if (data[0].__refresh_required) {
                                console.log("Payload too large, ignoring update to prevent disruption");
                                return;
                            }

                            const array = [];
                            const currentPropertyId = new URL(window.location.href).searchParams.get("property_id");
                            Object.keys(data[0]).forEach((key) => {
                                const booking = data[0][key];
                                if (currentPropertyId && String(booking.i) !== String(currentPropertyId)) return;
                                array.push(booking);
                            });

                            if (sortFilter === "asc") {
                                array.sort((a, b) => (a.n > b.n ? -1 : 1));
                            } else {
                                array.sort((a, b) => (a.n > b.n ? 1 : -1));
                            }

                            setBookings(array);
                            setChatsLoading(false);
                        }
                    });
            } else if (type === "collections") {
                if (messageLoading === false) {
                    setChatsLoading(true);
                }
                setLoading(false);
                setDoSub(type);
                setDoSubTag(collection_tag_id);

                // First make the API call to get initial data
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}collection_event/${collection_tag_id}`,
                }).then((response) => {
                    const array = [];
                    const currentPropertyId = new URL(window.location.href).searchParams.get("property_id");
                    Object.keys(response.data).forEach((key) => {
                        const booking = response.data[key];
                        if (currentPropertyId && String(booking.i) !== String(currentPropertyId)) return;
                        array.push(booking);
                    });

                    if (sortFilter === "asc") {
                        array.sort((a, b) => (a.n > b.n ? -1 : 1));
                    } else {
                        array.sort((a, b) => (a.n > b.n ? 1 : -1));
                    }

                    setBookings(array);
                    setChatsLoading(false);
                });

                // Then set up the Echo channel for real-time updates
                echo.channel(`CollectionMessages.${collection_tag_id}`)
                    .subscribed(() => {
                        // console.log("You are subscribed Message List Collections");
                    })
                    .listen("CollectionBookingEvent", (data) => {
                        if (data[1] === window.location.href.split("/").pop().split("=")[1].split("&")[0]) {
                            const array = [];
                            const currentPropertyId = new URL(window.location.href).searchParams.get("property_id");
                            Object.keys(data[0]).forEach((key) => {
                                const booking = data[0][key];
                                if (currentPropertyId && String(booking.i) !== String(currentPropertyId)) return;
                                array.push(booking);
                            });

                            if (sortFilter === "asc") {
                                array.sort((a, b) => (a.n > b.n ? -1 : 1));
                            } else {
                                array.sort((a, b) => (a.n > b.n ? 1 : -1));
                            }

                            setBookings(array);
                            setChatsLoading(false);
                        }
                    });
            } else if (type === "brokers") {
                if (messageLoading === false) {
                    setChatsLoading(true);
                }
                setLoading(false);
                setDoSub(type);
                setDoSubTag(1);

                // First make the API call to get initial data
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}brokersBookings_event/1`,
                });

                // Then set up the Echo channel for real-time updates
                echo.channel(`BrokerBookings.1`)
                    .subscribed(() => {
                        // console.log("You are subscribed Message List Brokers 2");
                    })
                    .listen("BrokersBookings", (data) => {
                        const array = [];
                        const currentPropertyId = new URL(window.location.href).searchParams.get("property_id");
                        Object.keys(data[0]).forEach((key) => {
                            const booking = data[0][key];
                            if (currentPropertyId && String(booking.i) !== String(currentPropertyId)) return;
                            array.push(booking);
                        });

                        if (sortFilter === "asc") {
                            array.sort((a, b) => (a.n > b.n ? -1 : 1));
                        } else {
                            array.sort((a, b) => (a.n > b.n ? 1 : -1));
                        }

                        setBookings(array);
                        setChatsLoading(false);
                    });
            } else if (type === "mentions") {
                // Fix for mentions - separated from the tag_id === null condition
                if (messageLoading === false) {
                    setChatsLoading(true);
                }
                setLoading(false);
                setDoSub(type);
                setDoSubMention(current_staff.id);

                // Make the API call to get mentions
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}mentions/${current_staff.id}`,
                })
                    .then((response) => {
                        const array = [];

                        // Process the response data
                        Object.keys(response.data).forEach((key) => {
                            let mentionArr = response.data[key].q !== null && response.data[key].q.includes(",") ? response.data[key].q.split(",") : [response.data[key].q];

                            if (mentionArr && mentionArr.includes(current_staff.id.toString())) {
                                array.push(response.data[key]);
                            }
                        });

                        // Apply sorting
                        if (sortFilter === "asc") {
                            array.sort((a, b) => (a.n > b.n ? -1 : 1));
                        } else {
                            array.sort((a, b) => (a.n > b.n ? 1 : -1));
                        }

                        setBookings(array);
                        setChatsLoading(false);
                    })
                    .catch((error) => {
                        console.error("Error fetching mentions:", error);
                        setChatsLoading(false);
                    });

                // Keep the Echo channel for real-time updates
                echo.channel(`MentionBooking.${current_staff.id}`)
                    .subscribed(() => {
                        // console.log("You are subscribed Message List Mentions");
                    })
                    .listen("MentionBookings", (data) => {
                        const array = [];
                        Object.keys(data).forEach((key) => {
                            let mentionArr = data[key].q !== null && data[key].q.includes(",") ? data[key].q.split(",") : [data[key].q];

                            if (mentionArr && mentionArr.includes(current_staff.id.toString())) {
                                array.push(data[key]);
                            }
                        });

                        if (sortFilter === "asc") {
                            array.sort((a, b) => (a.n > b.n ? -1 : 1));
                        } else {
                            array.sort((a, b) => (a.n > b.n ? 1 : -1));
                        }

                        setBookings(array);
                    });
            } else {
                // Handle both tagged and untagged views
                if (messageLoading === false) {
                    setChatsLoading(true);
                }
                setLoading(false);
                setDoSub(type);
                setDoSubTag(tag_id);
                if (type === "chat-tags" && pathnameLocation && pathnameLocation !== "chat-tags") {
                    // Chat tags use a separate pivot table (booking_chat_tags), not b.location
                    const chatTagId = pathnameLocation;
                    axios({
                        method: "get",
                        url: `${process.env.REACT_APP_API_URL}chat-tags/${chatTagId}/bookings`,
                    }).then((response) => {
                        const array = [];
                        Object.keys(response.data).forEach((key) => {
                            array.push(response.data[key]);
                        });

                        if (sortFilter === "asc") {
                            array.sort((a, b) => (a.n > b.n ? -1 : 1));
                        } else {
                            array.sort((a, b) => (a.n > b.n ? 1 : -1));
                        }

                        setBookings(array);
                        setChatsLoading(false);
                    });
                } else if (type !== "archived") {
                    axios({
                        method: "get",
                        url: `${process.env.REACT_APP_API_URL}get_folder/${type}${property_id ? `?property_id=${property_id}` : ''}`,
                    }).then((response) => {
                        const array = [];

                        // Handle the response data similar to archived
                        Object.keys(response.data).forEach((key) => {
                            array.push(response.data[key]);
                        });

                        // Apply the same sorting logic
                        if (sortFilter === "asc") {
                            array.sort((a, b) => (a.n > b.n ? -1 : 1));
                        } else {
                            array.sort((a, b) => (a.n > b.n ? 1 : -1));
                        }

                        setBookings(array);
                        setChatsLoading(false);
                    });
                } else {
                    if (tag_id) {
                        // Fetch archived bookings for a specific tag
                        const url = `${process.env.REACT_APP_API_URL}get_tagged_bookings/${tag_id}`;
                        axios({
                            method: "get",
                            url: url,
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                            },
                        })
                            .then((response) => {
                                if (!response.data) {
                                    console.error("No data in response");
                                    throw new Error("No data in response");
                                }
                                const array = [];
                                Object.keys(response.data).forEach((key) => {
                                    array.push(response.data[key]);
                                });

                                if (sortFilter === "asc") {
                                    array.sort((a, b) => (a.n > b.n ? -1 : 1));
                                } else {
                                    array.sort((a, b) => (a.n > b.n ? 1 : -1));
                                }

                                setBookings(array);
                                setChatsLoading(false);

                                // Update the subscription to listen for tag-specific updates
                                setDoSub(type);
                                setDoSubTag(tag_id);
                            })
                            .catch((error) => {
                                console.error("Error fetching tagged archived bookings:", error);
                                setChatsLoading(false);
                            });
                    } else {
                        // Fetch all archived bookings
                        axios({
                            method: "get",
                            url: `${process.env.REACT_APP_API_URL}get_archived`,
                        })
                            .then((response) => {
                                const array = [];
                                Object.keys(response.data).forEach((key) => {
                                    array.push(response.data[key]);
                                });

                                if (sortFilter === "asc") {
                                    array.sort((a, b) => (a.n > b.n ? -1 : 1));
                                } else {
                                    array.sort((a, b) => (a.n > b.n ? 1 : -1));
                                }

                                setBookings(array);
                                setChatsLoading(false);

                                // Reset the tag subscription
                                setDoSub(type);
                                setDoSubTag(null);
                            })
                            .catch((error) => {
                                console.error("Error fetching archived bookings:", error);
                                setChatsLoading(false);
                            });
                    }
                }

                // Set up Echo channel for real-time updates
                const channelName = doSubTag ? `TagMessages.${doSubTag}` : `Messages.${sanitizeChannelName(type)}`;
                const eventName = doSubTag ? "TagBookingsEvent" : "GetBookings";

                echo.channel(channelName)
                    .subscribed(() => {
                        // Subscribed
                    })
                    .listen(eventName, (data) => {
                        const currentType = window.location.href.split("/").pop().split("?")[0];
                        const sanitizedCurrentType = sanitizeChannelName(currentType);
                        if (data[1] === sanitizedCurrentType) {
                            // Check if payload was too large - if so, do nothing to avoid disrupting user
                            if (data[0].__refresh_required) {
                                return;
                            }

                            const array = [];
                            const currentPropertyId = new URL(window.location.href).searchParams.get("property_id");

                            Object.keys(data[0]).forEach((key) => {
                                const booking = data[0][key];
                                // Filter by property_id if one is set in the URL
                                if (currentPropertyId && String(booking.i) !== String(currentPropertyId)) return;
                                array.push(booking);
                            });

                            if (sortFilter === "asc") {
                                array.sort((a, b) => (a.n > b.n ? -1 : 1));
                            } else {
                                array.sort((a, b) => (a.n > b.n ? 1 : -1));
                            }

                            setBookings(array);
                            setChatsLoading(false);
                        }
                    });
            }
        }

        if (sortFilter !== sortDir) {
            setSortDir(sortFilter);

            let allBookings = bookings;

            if (sortFilter === "asc") {
                allBookings.sort((a, b) => (a.n > b.n ? -1 : 1));
                // allBookings.sort((a, b) => (a.last_message_sent > b.last_message_sent ? -1 : 1));
            } else {
                allBookings.sort((a, b) => (a.n > b.n ? 1 : -1));
                // allBookings.sort((a, b) => (a.last_message_sent > b.last_message_sent ? 1 : -1));
            }

            setBookings(allBookings);
        }

        //&& ignoreRefresh === false

        if ((current_booking !== undefined && messageLoading === true) || ignoreRefresh === true) {
            //Axio call to get all messages

            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}get_booking_messages`,
                data: { booking_id: current_booking.id },
            }).then((response) => {
                // Handle both old format (array) and new format (object with messages array)
                let data = Array.isArray(response.data) ? response.data : response.data.messages;
                const array = [];
                
                // Store pagination metadata
                if (!Array.isArray(response.data)) {
                    setMessagesPagination({
                        total: response.data.total || 0,
                        limit: response.data.limit || 1000,
                        offset: response.data.offset || 0,
                        has_more: response.data.has_more || false
                    });
                    
                    // Log warning if chat has many messages
                    if (response.data.total > 1000) {
                        console.warn(`Large chat history: ${response.data.total} messages (showing most recent ${response.data.limit})`);
                    }
                }
                
                Object.keys(data).forEach((key) => {
                    if (data[key].files !== null) {
                        data[key].files = data[key].files.split(",");
                    } else {
                        data[key].files = [];
                    }

                    data[key].timestamp = format(new Date(data[key].created_at), "dd MMM yyyy HH:mm:ss");
                    data[key].from = parseInt(data[key].from);
                    data[key].to = parseInt(data[key].to);
                    array.push(data[key]);
                });
                setMessages(array);
                setMessageLoading(false);
                setChatsMsgLoading(false);
            });
        }

        let assignedFilter = "all";

        if (type === "mentions") {
            assignedFilter = "mine";
        }

        if (props.history.action == "POP") {
            if (allowClick === true) {
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}channels`,
                });
                // axios({
                //     method: "get",
                //     url: `${process.env.REACT_APP_API_URL}unified`,
                // });
                if (settings && settings.brokers === 1) {
                    axios({
                        method: "get",
                        url: `${process.env.REACT_APP_API_URL}brokers`,
                    });
                }
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}tagsList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}collectionList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}event/${type}`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}mentionList/${current_staff.id}`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}tag_event/${tag_id}/${type}`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}collection_event/${collection_tag_id}`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}mentions/${current_staff.id}`,
                });

                setAllowClick(false);
            }
        }

        if (user_id > 0 && (current_booking === undefined || current_booking.user.id !== user_id) && messageLoading === false && ignoreRefresh === false) {
            setMessageLoading(true);
            dispatch(getBooking(0, user_id, active_booking_id));
        }

        setIgnoreRefresh(false);

        return () => {
            echo.disconnect();
        };
    }, [current_booking, current_staff, type, tag_id, collection_tag_id, sortFilter, filterLocation, msgCount, showNewMessages, user_id, property_id, pathnameLocation]);

    // Auto-open cancellations modal if URL has opencancellations=1
    useEffect(() => {
        if (openCancellations === '1' && current_booking?.id && !showCancellationsModal) {
            setShowCancellationsModal(true);
        }
    }, [current_booking?.id, openCancellations]);

    useEffect(() => {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}linked_chats/${current_booking?.id}`,
        })
            .then((response) => {
                setLinkedChats(response.data);
            })
            .catch((error) => {
                // alert("Failed to get linked chats");
            })
            .finally(() => {
                setLinkedLoading(false);
            });
    }, [linkedLoading, current_booking]);

    // Unit-mates for the linked-chats bar. Only QL/QP group by unit; UC's bar uses
    // the directly-linked chats (linkedChats) above, so skip this fetch on UC.
    useEffect(() => {
        if (isUC || !current_booking?.id) return;
        axios({
            method: "get",
            url: `${process.env.REACT_APP_API_URL}unit_chats/${current_booking?.id}`,
        })
            .then((response) => {
                setUnitChats(response.data);
            })
            .catch((error) => {
                // alert("Failed to get unit chats");
            });
    }, [current_booking, isUC]);

    useEffect(() => {
        axios.defaults.baseURL = process.env.REACT_APP_API_URL;

        let echo;

        if (process.env.REACT_APP_REVERB_APP_ID) {
            echo = new Echo({
                broadcaster: "reverb", // Change "pusher" to "reverb"
                key: process.env.REACT_APP_REVERB_APP_KEY,
                wsHost: process.env.REACT_APP_REVERB_URL,
                wssHost: process.env.REACT_APP_REVERB_URL,
                wsPort: process.env.REACT_APP_REVERB_PORT,
                wssPort: process.env.REACT_APP_REVERB_PORT,
                disableStats: true,
                encrypted: process.env.REACT_APP_REVERB_SCHEME === "https",
                forceTLS: process.env.REACT_APP_REVERB_SCHEME === "https",
                enableLogging: true,
            });
        } else {
            echo = new Echo({
                broadcaster: "pusher",
                key: process.env.REACT_APP_MIX_ABLY_PUBLIC_KEY,

                wsHost: process.env.REACT_APP_MIX_ABLY_URL,
                wssHost: process.env.REACT_APP_MIX_ABLY_URL,

                wsPort: process.env.REACT_APP_MIX_ABLY_PORT,
                wssPort: process.env.REACT_APP_MIX_ABLY_PORT,

                disableStats: true,
                encrypted: false,
                enabledTransports: ["ws", "wss"],
                forceTLS: false,

                enableLogging: true,

                // unavailableTimeout: 1000,
                // activityTimeout: 1000,
                // pongTimeout: 2000,
            });
        }

        if (current_booking) {
            echo.channel(`incomingMessage.${current_booking.id}`)
                .subscribed(() => {
                    // console.log("You are subscribes to incoming messages");
                })
                .listen(".IncomingMessageEvent", (data) => {
                    if (data.files && typeof data.files === "string") {
                        data.files = data.files.split(",");
                    } else {
                        data.files = [];
                    }

                    data.timestamp = format(new Date(data.created_at), "dd MMM yyyy HH:mm:ss");
                    data.from = parseInt(data.from);
                    data.to = parseInt(data.to);

                    setMessages((prevMessages) => {
                        // Check if this is an update to an existing message
                        const existingIndex = prevMessages.findIndex((msg) => msg.id === data.id);

                        if (existingIndex >= 0) {
                            // Update existing message - preserve any existing fields not in the update
                            const updatedMessages = [...prevMessages];
                            updatedMessages[existingIndex] = {
                                ...updatedMessages[existingIndex], // Keep existing fields
                                ...data, // Apply updates
                                // Ensure we don't override these with null/undefined
                                files: data.files || updatedMessages[existingIndex].files || [],
                                timestamp: data.timestamp || updatedMessages[existingIndex].timestamp,
                            };
                            return updatedMessages;
                        } else {
                            // Add new message
                            return [...prevMessages, data];
                        }
                    });

                    // Play sound for new messages and successful status updates
                    if (data.event_type === "new_message" || (data.event_type === "status_update" && data.send_status === "Delivered")) {
                        const isMobileDevice = () => /Mobi|Android/i.test(navigator.userAgent) || window.matchMedia("(max-width: 768px)").matches;

                        if (isMobileDevice()) {
                            const audio = new Audio("/message.mp3");
                            audio.play().catch((e) => console.log("Audio play failed:", e));
                        }
                    }
                });

            echo.channel(`InstantMessage.${current_booking.id}`)
                .subscribed(() => {
                    // console.log("You are subscribes to instant messages");
                })
                .listen(".InstantMessageEvent", (data) => {
                    if (data.files && typeof data.files === "string") {
                        data.files = data.files.split(",");
                    } else {
                        data.files = [];
                    }

                    data.timestamp = format(new Date(data.created_at), "dd MMM yyyy HH:mm:ss");
                    data.from = parseInt(data.from);
                    data.to = parseInt(data.to);

                    setMessages((prevMessages) => {
                        // Check if this is an update to an existing message
                        const existingIndex = prevMessages.findIndex((msg) => msg.id === data.id);

                        if (existingIndex >= 0) {
                            // Update existing message
                            const updatedMessages = [...prevMessages];
                            updatedMessages[existingIndex] = {
                                ...updatedMessages[existingIndex],
                                ...data,
                                files: data.files || updatedMessages[existingIndex].files || [],
                                timestamp: data.timestamp || updatedMessages[existingIndex].timestamp,
                            };
                            return updatedMessages;
                        } else {
                            // Add new message
                            return [...prevMessages, data];
                        }
                    });

                    // Play sound for new messages
                    if (data.event_type === "new_message") {
                        const isMobileDevice = () => /Mobi|Android/i.test(navigator.userAgent) || window.matchMedia("(max-width: 768px)").matches;

                        if (isMobileDevice()) {
                            const audio = new Audio("/message.mp3");
                            audio.play().catch((e) => console.log("Audio play failed:", e));
                        }
                    }
                });
        }

        return () => {
            echo.disconnect();
        };
    }, [current_booking]);

    var url_string = window.location.href;

    var url = new URL(url_string);
    var tag_id = url.searchParams.get("tag");
    var collection_tag_id = url.searchParams.get("collection_tag");
    var view_property_id = url.searchParams.get("property_id");
    var booking_list_name = type;

    if (tag_id) {
        var tag_data = tags.find((tag) => tag.id === parseInt(tag_id));
        booking_list_name = tag_data?.name;
    }

    if (collection_tag_id) {
        if (collection_tag_id == -1) {
            booking_list_name = "All Collections";
        } else {
            var collection_data = collections.find((collection) => collection.id === parseInt(collection_tag_id));
            booking_list_name = collection_data?.name;
        }
    }

    // else{
    //     var folder_data = folders.find((folder) => folder.href.split('/').pop() === type);
    //     booking_list_name = folder_data?.name;

    //     if(type === "mentions"){
    //         booking_list_name = "Mentions"
    //     }
    // }

    async function checkMailbox() {
        // This function is now a no-op since TPN functionality is handled in the CreditCheck component
        // The actual mailbox check should be triggered from within the CreditCheck component
        return;
    }

    function mda_create_tenant(type, action) {
        if (type === "tenant" && action === "create") {
            setMdaLoadingT(true);

            axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}mda/create_tenant/${current_booking.user.id}/${current_booking.id}`,
                data: { current_staff: current_staff },
            })
                .then((response) => {
                    let resp = response.data.split("|");

                    if (resp[0] === "updated" || resp[0] === "done") {
                        dispatch(getBooking(current_booking.id));

                        toast(<NotificationToast title={"Tenant Created"} message={"A tenant has been created on MDA"} />);
                    } else {
                        toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />, {
                            autoClose: false,
                        });
                    }
                })
                .catch((response) => {
                    toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />);
                })
                .finally(() => {
                    setMdaLoadingT(false);
                });
        } else if (type === "tenant" && action === "delete") {
            setMdaLoadingT(true);

            axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}mda/delete_tenant/${current_booking.user.id}/${current_booking.id}`,
                data: { current_staff: current_staff },
            })
                .then((response) => {
                    if (response.data === "done") {
                        dispatch(getBooking(current_booking.id));

                        toast(<NotificationToast title={"Tenant Deleted"} message={"A tenant has been deleted on MDA"} />);
                    } else {
                        toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />, {
                            autoClose: false,
                        });
                    }
                })
                .catch((response) => {
                    toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />);
                })
                .finally(() => {
                    setMdaLoadingT(false);
                });
        } else if (type == "lease" && action == "create") {
            setMdaLoadingL(true);

            axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}mda/create_lease/${current_booking.user.id}/${current_booking.id}`,
                data: { current_staff: current_staff },
            })
                .then((response) => {
                    if (response.data === "done" || response === "done") {
                        dispatch(getBooking(current_booking.id));

                        toast(<NotificationToast title={"Lease Created"} message={"A lease has been created on MDA"} />);
                    } else {
                        if (response.data === "Can't find Unit!") {
                            dispatch(
                                openModal({
                                    modal_type: "ModalMDAChooseUnit",
                                    modal_props: { current_booking: current_booking },
                                }),
                            );
                        } else {
                            toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />, {
                                autoClose: false,
                            });
                        }
                    }
                })
                .catch((response) => {
                    toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />);
                })
                .finally(() => {
                    setMdaLoadingL(false);
                });
        } else if (type == "lease" && action == "delete") {
            setMdaLoadingL(true);

            axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}mda/delete_lease/${current_booking.user.id}/${current_booking.id}`,
                data: { current_staff: current_staff },
            })
                .then((response) => {
                    if (response.data === "done") {
                        dispatch(getBooking(current_booking.id));

                        toast(<NotificationToast title={"Lease Deleted"} message={"A lease has been deleted on MDA"} />);
                    } else {
                        toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />, {
                            autoClose: false,
                        });
                    }
                })
                .catch((response) => {
                    toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />);
                })
                .finally(() => {
                    setMdaLoadingL(false);
                });
        } else if (type == "lease" && action == "unlink") {
            setMdaLoadingL(true);

            axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}mda/unlink_lease/${current_booking.user.id}/${current_booking.id}`,
                data: { current_staff: current_staff },
            })
                .then((response) => {
                    // if (response == "done") {
                    //     dispatch(getBooking(current_booking.id));

                    //     toast(<NotificationToast title={"Lease Unlinked"} message={"A lease has been unlinked from MDA"} />);
                    // } else {
                    //     toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />, {
                    //         autoClose: false,
                    //     });
                    // }

                    dispatch(getBooking(current_booking.id));

                    toast(<NotificationToast title={"Lease Unlinked"} message={"A lease has been unlinked from MDA"} />);
                })
                .catch((response) => {
                    toast(<NotificationToast title={"MDA Issue"} message={response.data} type="error" />);
                })
                .finally(() => {
                    setMdaLoadingL(false);
                });
        }
    }

    async function switchWiFi(user_id, use_mac, id, count) {
        if (count === 1) {
            setWiFiLoading(true);
        } else {
            setWiFiLoading2(true);
        }

        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}wifi-status-update`,
            data: {
                user_id: user_id,
                wifi_property_id: current_booking?.property?.wifi_property_id,
                current_staff: current_staff,
                use_mac: use_mac,
                id: id,
            },
        })
            .then((response) => {
                setIgnoreRefresh(true);
                dispatch(getBooking(current_booking.id));
                toast(<NotificationToast title={"WIFI Status Updated"} message={"WiFi Updated"} />);
            })
            .catch((response) => {
                toast(<NotificationToast title={"WIFI Issue"} message={response.data} type="error" />);
            })
            .finally(() => {
                setWiFiLoading(false);
                setWiFiLoading2(false);
            });
    }

    async function unlinkWifiAccount() {
        setWiFiLoading(true);

        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}wifi-unlink-account`,
            data: {
                user_id: user_id,
                wifi_property_id: current_booking?.property?.wifi_property_id,
                wifi_package_id: current_booking?.property?.wifi_package_id,
                current_staff: current_staff,
                current_booking_id: current_booking.id,
            },
        })
            .then((response) => {
                setIgnoreRefresh(true);
                dispatch(getBooking(current_booking.id));
                toast(<NotificationToast title={"WIFI Account Unlinked"} message={"WiFi Unlinked"} />);
            })
            .catch((response) => {
                toast(<NotificationToast title={"WIFI Issue"} message={response.data} type="error" />);
            })
            .finally(() => {
                setWiFiLoading(false);
            });
    }

    async function linkWifiAccount() {
        setWiFiLoading(true);

        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}wifi-link-account`,
            data: {
                user_id: user_id,
                wifi_property_id: current_booking?.property?.wifi_property_id,
                wifi_package_id: current_booking?.property?.wifi_package_id,
                current_staff: current_staff,
                current_booking_id: current_booking.id,
            },
        })
            .then((response) => {
                setIgnoreRefresh(true);
                dispatch(getBooking(current_booking.id));
                toast(<NotificationToast title={"WIFI Account Linked"} message={"WiFi Linked"} />);
            })
            .catch((response) => {
                toast(<NotificationToast title={"WIFI Issue"} message={response.data} type="error" />);
            })
            .finally(() => {
                setWiFiLoading(false);
            });
    }

    async function createWifiAccount(booking_id) {
        setWiFiLoading(true);

        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}wifi-create-account`,
            data: {
                booking_id: booking_id,
                wifi_property_id: current_booking?.property?.wifi_property_id,
                wifi_package_id: current_booking?.property?.wifi_package_id,
                current_staff: current_staff,
            },
        })
            .then((response) => {
                setIgnoreRefresh(true);
                dispatch(getBooking(current_booking.id));
                toast(<NotificationToast title={"WIFI Account Created"} message={"WiFi Created"} />);
            })
            .catch((response) => {
                toast(<NotificationToast title={"WIFI Issue"} message={response.data} type="error" />);
            })
            .finally(() => {
                setWiFiLoading(false);
            });
    }

    async function removeWifiAccount() {
        setWiFiLoading(true);

        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}remove-wifi-account`,
            data: {
                booking_id: current_booking.id,
                current_staff: current_staff,
            },
        })
            .then((response) => {
                setIgnoreRefresh(true);
                dispatch(getBooking(current_booking.id));
                toast(<NotificationToast title={"WIFI Account Removed"} message={"WiFi Removed"} />);
            })
            .catch((response) => {
                toast(<NotificationToast title={"WIFI Issue"} message={response.data} type="error" />);
            })
            .finally(() => {
                setWiFiLoading(false);
            });
    }

    async function checkWifi(property_id, account_id, username) {
        if (account_id !== null && username === null) {
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL}wifi-check-details`,
                data: { user_id: user_id, wifi_property_id: property_id, wifi_account_id: account_id },
            })
                .then((response) => {
                    setIgnoreRefresh(true);
                    dispatch(getBooking(current_booking.id));
                    // toast(<NotificationToast title={"WIFI Account Created"} message={"WiFi Created"} />);
                })
                .catch((response) => {
                    // toast(<NotificationToast title={"WIFI Issue"} message={response.data} type="error" />);
                })
                .finally(() => {
                    // setWiFiLoading(false);
                });
        }
    }

    async function requestPhoto(id) {
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}bookings/${id}/request_photo`,
        })
            .then((response) => {
                dispatch(getBooking(current_booking.id));
                toast(<NotificationToast title={"Photo Request"} message={response.data.message} />);
            })
            .catch((error) => {
                alert("Photo request failed.");
            });
    }

    async function removeAccess(id) {
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}bookings/${id}/revoke_hik_access`,
        })
            .then((response) => {
                // dispatch(getBooking(current_booking.id));
                toast(<NotificationToast title={"Access Revoked"} message={response.data.message} />);
            })
            .catch((error) => {
                alert("Access Revoke failed.");
            });
    }

    if (loading === true) return <AppLoader />;

    return (
        <>
            {/* Month-End Dashboard Modal */}
            {isMonthendFolder() && (
                <MonthendDashboardModal 
                    isOpen={showDashboard}
                    onClose={() => setShowDashboard(false)}
                    folderType={getMonthendFolderType()}
                    initialPropertyId={property_id}
                    onOpenBookingCancellations={(booking) => {
                        const link = `/booking/${(booking.location || 'all').toLowerCase().replace(/\s+/g, '')}?user_id=${booking.user?.id}&booking_id=${booking.id}&property_id=${booking.property_id || ''}&opencancellations=1`;
                        window.open(link, '_blank');
                    }}
                />
            )}
            
            {/* Cancellations and Renewals Modal */}
            <CancellationsModal 
                isOpen={showCancellationsModal}
                onClose={() => setShowCancellationsModal(false)}
                onOpenReport={() => { setShowCancellationsModal(false); setShowDashboard(true); }}
            />
            
            {/* Main Content - Always visible */}
            <>
                    {/* 3 column wrapper */}
                    <div className="px-1 sm:px-4 my-2 xl:my-0 h-screen xl:flex w-full ">
                {/* Left sidebar & main wrapper */}
                {/* Start left column area */}
                <div className="rounded-3xl bg-light_background w-full xl:w-72 xl:relative flex-none">
                    <div className="min-h-14 flex rounded-t-3xl items-center justify-between px-4 bg-dark_background z-20 xl:w-72 relative xl:fixed">
                        <h3 className="text-sm leading-6 font-light text-white capitalize">
                            {booking_list_name}
                            {filterLocation.name !== "" && <div className="text-xs">{filterLocation.name}</div>}
                            {filterGender.name !== "" && <div className="text-xs">{filterGender.name}</div>}
                            {filterFunding.name !== "" && <div className="text-xs">{filterFunding.name}</div>}
                            {filterStudyYear.name !== "" && <div className="text-xs">{filterStudyYear.name}</div>}
                            {type === "collections" && filterVendor.name !== "" && <div className="text-xs">{filterVendor.name}</div>}
                            {type === "collections" && filterStatus.name !== "" && <div className="text-xs">{filterStatus.name}</div>}
                            {filterTenantType.name !== "" && <div className="text-xs">{filterTenantType.name}</div>}
                            {filterCount > 0 && <div className="text-xs">(Total: {filterCount})</div>}
                        </h3>

                        <div className="space-x-1 flex justify-end items-center">
                            <button
                                type="button"
                                className="text-white uppercase px-2 py-1 rounded-lg border text-sm focus:z-10 focus:outline-none border-primary bg-primary hover:bg-primary_hover focus:ring-primary focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 mt-1"
                                onClick={() => {
                                    dispatch(
                                        openModal({
                                            modal_type: "ModalFilterMessages",
                                            modal_props: {
                                                filterLocation,
                                                setFilterLocation,
                                                filterGender,
                                                setFilterGender,
                                                filterFunding,
                                                setFilterFunding,
                                                filterVendor,
                                                setFilterVendor,
                                                filterStatus,
                                                setFilterStatus,
                                                properties,
                                                genderOptions,
                                                fundingOptions,
                                                booking_list_name,
                                                filterDocuments,
                                                setFilterDocuments,
                                                type: type,
                                                tag_id: tag_id,
                                                collection_tag_id: collection_tag_id,
                                                current_staff_id: current_staff.id,
                                                filterStudyYear: filterStudyYear,
                                                setFilterStudyYear: setFilterStudyYear,
                                                filterUnitType: filterUnitType,
                                                setFilterUnitType: setFilterUnitType,
                                                filterBookingSummary: filterBookingSummary,
                                                setFilterBookingSummary: setFilterBookingSummary,
                                                filterBudget: filterBudget,
                                                setFilterBudget: setFilterBudget,
                                                lookups: lookups,
                                                filterBotFlow: filterBotFlow,
                                                setFilterBotFlow: setFilterBotFlow,
                                                filterAppointment: filterAppointment,
                                                setFilterAppointment: setFilterAppointment,
                                                filterBalance: filterBalance,
                                                setFilterBalance: setFilterBalance,
                                                filterRenewalChoice: filterRenewalChoice,
                                                setFilterRenewalChoice: setFilterRenewalChoice,
                                                filterTenantType: filterTenantType,
                                                setFilterTenantType: setFilterTenantType,
                                            },
                                        }),
                                    );
                                }}
                            >
                                <FontAwesomeIcon icon={faFilter} className="h-5 w-5 text-white" />
                            </button>

                            {!current_staff.building_manager && !current_staff.hideBulkMessages && current_staff.status === "Admin" && current_staff.status !== "Staff" && current_staff.status !== "Dual" ? (
                                <button
                                    type="button"
                                    className="text-white uppercase px-2 py-1 rounded-lg border text-sm focus:z-10 focus:outline-none border-primary bg-primary hover:bg-primary_hover focus:ring-primary focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 mt-1"
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                modal_type: "ModalBulkMessages",
                                                modal_props: {
                                                    allBookings,
                                                    bookings,
                                                    booking_list_name,
                                                    current_staff,
                                                    staff,
                                                    location_type: type,
                                                    tag_id,
                                                    collection_tag_id,
                                                    property_id: view_property_id,
                                                    lookups,
                                                },
                                            }),
                                        )
                                    }
                                >
                                    <FontAwesomeIcon icon={faEnvelopesBulk} className="h-5 w-5 text-white" />
                                </button>
                            ) : (
                                ""
                            )}

                            {/* Dashboard toggle for month-end folders */}
                            {isMonthendFolder() && (
                                <button
                                    type="button"
                                    className="text-white uppercase px-2 py-1 rounded-lg border text-sm focus:z-10 focus:outline-none border-primary bg-primary hover:bg-primary_hover focus:ring-primary focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 mt-1"
                                    onClick={() => setShowDashboard(!showDashboard)}
                                    title={showDashboard ? 'Show List View' : 'Show Month-End Dashboard'}
                                >
                                    <FontAwesomeIcon icon={showDashboard ? faListCheck : faChartLine} className="h-5 w-5 text-white" />
                                </button>
                            )}

                            {!current_staff.building_manager && !current_staff.hideBulkActions && current_staff.status === "Admin" && current_staff.status !== "Staff" && current_staff.status !== "Dual" ? (
                                <button
                                    type="button"
                                    className="text-white uppercase px-2 py-1 rounded-lg border text-sm focus:z-10 focus:outline-none border-primary bg-primary hover:bg-primary_hover focus:ring-primary focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-ease-out hover:-translate-y-0.5 mt-1"
                                    onClick={() =>
                                        dispatch(
                                            openModal({
                                                modal_type: "ModalBulkArchive",
                                                modal_props: {
                                                    allBookings,
                                                    bookings,
                                                    booking_list_name,
                                                    current_staff,
                                                    staff,
                                                    type,
                                                    tag_id,
                                                    collection_tag_id,
                                                    property_id: view_property_id,
                                                    lookups,
                                                },
                                            }),
                                        )
                                    }
                                >
                                    <FontAwesomeIcon icon={faLock} className="h-5 w-5 text-white" />
                                </button>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>

                    <BookingList
                        setMessageLoading={setMessageLoading}
                        bookings={bookings}
                        setFilterCount={setFilterCount}
                        setSortFilter={setSortFilter}
                        setMsgCount={setMsgCount}
                        tag_id={tag_id}
                        collection_tag_id={collection_tag_id}
                        setShowNewMessages={setShowNewMessages}
                        filterLocation={filterLocation}
                        filterGender={filterGender}
                        filterFunding={filterFunding}
                        filterVendor={filterVendor}
                        filterStatus={filterStatus}
                        chatsLoading={chatsLoading}
                        filterStudyYear={filterStudyYear}
                        filterUnitType={filterUnitType}
                        filterBookingSummary={filterBookingSummary}
                        filterBudget={filterBudget}
                        filterBotFlow={filterBotFlow}
                        filterDocuments={filterDocuments}
                        filterAppointment={filterAppointment}
                        filterBalance={filterBalance}
                        filterRenewalChoice={filterRenewalChoice}
                        filterTenantType={filterTenantType}
                        setFilterTenantType={setFilterTenantType}
                        property_id={property_id}
                    />
                </div>
                {/* End left column area */}

                <div className="bg-gray-100 my-6 xl:my-0 xl:mx-4 rounded-3xl flex-1 overflow-hidden flex flex-col">
                    {!current_booking && !messageLoading && <h1 className="p-4 h-full flex justify-center text-xl items-center">Select a booking to start a conversation</h1>}

                    {messageLoading && (
                        <h1 className="h-full flex justify-center text-2xl items-center">
                            <LoadingIcon />
                        </h1>
                    )}

                    {current_booking && !messageLoading && (
                        <ErrorBoundary>
                            <div className="px-4 flex space-x-2 items-center relative rounded-t-3xl justify-between h-32 sm:h-14 bg-dark_background flex-wrap z-10 flex-none">
                                <div className="flex items-center">
                                    <h3
                                        className={classNames(
                                            flagged_ids.length > 0 && flagged_ids.includes(current_booking?.user?.profile?.id_number)
                                                ? "text-red-400"
                                                : current_booking.name_override !== null
                                                  ? "text-green-400"
                                                  : current_booking?.year_id === settings.year_id
                                                    ? "text-yellow-400"
                                                    : "text-white",
                                            " text-sm font-light leading-none",
                                        )}
                                    >
                                        {current_booking?.property?.banking_reference}
                                        {current_booking?.unit?.name}
                                        {current_booking?.bed?.name}
                                        {current_booking?.unit_type?.name && " - " + current_booking?.unit_type?.name}
                                        {process.env.REACT_APP_COLOUR === "UC" && (
                                            <>
                                                <br />
                                                {current_booking?.student_type === 3 && "Private | "}
                                                {current_booking?.student_type === 2 && "Bursary (" + current_booking?.user?.parent?.name + ") | "}
                                                {current_booking?.student_type === 8 && "NDT | "}
                                                {(current_booking?.student_type === 1 || current_booking?.student_type === 4 || current_booking?.student_type === 6) && "NSFAS | "}
                                            </>
                                        )}
                                        {" - "}
                                        {current_booking?.year?.year}
                                        {current_booking?.waiting_bed_id > 0 ? " or similar. (on waitlist)" : ""}
                                    </h3>
                                </div>

                                <div className="flex items-center justify-end w-1/4">
                                    {current_booking?.previously_declined > 0 && (
                                        <div className="mr-2">
                                            <FontAwesomeIcon
                                                icon={faExclamationTriangle}
                                                className="h-5 w-5 text-orange-500 cursor-help"
                                                title="Previously declined application"
                                            />
                                        </div>
                                    )}
                                    {getDaysSinceScan(current_booking?.user?.hik_last_scan) !== null && (
                                        <div
                                            className={`text-md ${getScanIconColor(getDaysSinceScan(current_booking?.user?.hik_last_scan))} mr-2 cursor-help`}
                                            title={formatScanDate(current_booking?.user?.hik_last_scan)}
                                        >
                                            {getDaysSinceScan(current_booking?.user?.hik_last_scan)}
                                        </div>
                                    )}
                                    <div className="mr-4">
                                        <FontAwesomeIcon
                                            icon={faScannerKeyboard}
                                            className={`h-5 w-5 ${getScanIconColor(getDaysSinceScan(current_booking?.user?.hik_last_scan))} cursor-help`}
                                            title={formatScanDate(current_booking?.user?.hik_last_scan)}
                                        />
                                    </div>

                                    <div>{(isUC ? linkedChats : unitChats).length > 0 && <FontAwesomeIcon icon={faPeople} className="h-5 w-5 text-primary mr-2" />}</div>

                                    <BookingButtons setLoading={setLoading} current_booking={current_booking} historicBookings={historicBookings} />
                                </div>

                                {/* <div className="flex">
                                    {current_booking?.assigned_to?.length > 0 &&
                                        current_booking.assigned_to.map((a) => <ProfilePicture key={a} id={parseInt(a)} size="40" />)}
                                </div> */}
                            </div>
                            <div className="flex-1 flex flex-col overflow-hidden min-h-0">
                                {chatsMsgLoading === true ? (
                                    <div className="w-full h-full text-center">
                                        <span className="text-blue-comparemed top-1/2 my-0 mx-auto block relative w-72 h-72">
                                            <FontAwesomeIcon icon={faSpinnerThird} className="text-black animate-spin text-5xl" />
                                        </span>
                                    </div>
                                ) : (
                                    <div className="flex-1 flex flex-col overflow-hidden min-h-0">
                                        <LinkedChatsBar
                                            current_booking={current_booking}
                                            linkedChats={isUC ? linkedChats : unitChats}
                                            messagesPagination={{
                                                has_more: messagesPagination.has_more,
                                                loaded: messages.length,
                                                total: messagesPagination.total,
                                                onLoadMore: loadOlderMessages,
                                                loading: loadingOlderMessages
                                            }}
                                            showMemoryWarning={showMemoryWarning}
                                            setShowMemoryWarning={setShowMemoryWarning}
                                        />
                                        <div className="flex-1 overflow-y-auto min-h-0">
                                            <BookingMessages 
                                                messages={messages} 
                                                setMsgCount={setMsgCount}
                                                totalMessages={messagesPagination.total}
                                                loadedMessages={messages.length}
                                                showMemoryWarning={showMemoryWarning}
                                                setShowMemoryWarning={setShowMemoryWarning}
                                                hasMoreMessages={messagesPagination.has_more}
                                            />
                                        </div>
                                    </div>
                                )}

                                <PropertyInterestIndicator />

                                <div className="flex-none">
                                    <BookingForm type={type} tag_id={tag_id} />
                                </div>
                            </div>
                        </ErrorBoundary>
                    )}
                </div>

                <div className="my-6 xl:my-0 flex-none h-full overflow-y-scroll">
                    {/* Start right column area */}
                    {current_booking && !messageLoading && (
                        <>
                            {current_staff && !!current_staff.show_dev_stuff && (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${
                                                        open ? "rounded-t-3xl" : "rounded-3xl"
                                                    } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14 transition duration-100 lineaer`}
                                                >
                                                    <FontAwesomeIcon icon={faGear} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Dev Stuff</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="rounded-b-3xl px-4 py-4 bg-gray-100 w-full ease-in duration-300">
                                                        {open && (
                                                            <RogersStuff
                                                                current_booking={current_booking}
                                                                current_staff={current_staff}
                                                                refreshBooking={() => dispatch(getBooking(current_booking.id))}
                                                            />
                                                        )}
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                </>
                            )}

                            <Disclosure defaultOpen={permissions?.includes('linked_chats_default_open') || false}>
                                {({ open }) => (
                                    <div className="xl:w-80">
                                        <Disclosure.Button
                                            className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                            onClick={() => !open && setLinkedLoading(true)}
                                        >
                                            <FontAwesomeIcon icon={faPeople} className="h-5 w-5 text-primary" />
                                            <h3 className="font-light text-sm text-white">Linked Chats</h3>
                                        </Disclosure.Button>
                                        <Transition
                                            enter="transition duration-100 ease-out"
                                            enterFrom="transform scale-95 opacity-0"
                                            enterTo="transform scale-100 opacity-100"
                                            leave="transition duration-75 ease-out"
                                            leaveFrom="transform scale-100 opacity-100"
                                            leaveTo="transform scale-95 opacity-0"
                                        >
                                            <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                <LinkedChats current_booking={current_booking} linkedChats={linkedChats} setLinkedChats={setLinkedChats} setLinkedLoading={setLinkedLoading} />
                                            </Disclosure.Panel>
                                        </Transition>
                                    </div>
                                )}
                            </Disclosure>
                            <br />

                            <Disclosure>
                                {({ open }) => (
                                    <div className="xl:w-80">
                                        <Disclosure.Button
                                            className={`${
                                                open ? "rounded-t-3xl" : "rounded-3xl"
                                            } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14 transition duration-100 lineaer`}
                                        >
                                            <FontAwesomeIcon icon={faUser} className="h-5 w-5 text-primary" />
                                            <h3 className="font-light text-sm text-white">Applicant Information</h3>
                                        </Disclosure.Button>
                                        <Transition
                                            enter="transition duration-100 ease-out"
                                            enterFrom="transform scale-95 opacity-0"
                                            enterTo="transform scale-100 opacity-100"
                                            leave="transition duration-75 ease-out"
                                            leaveFrom="transform scale-100 opacity-100"
                                            leaveTo="transform scale-95 opacity-0"
                                        >
                                            <Disclosure.Panel className="rounded-b-3xl px-4 py-4 bg-gray-100 w-full ease-in duration-300">
                                                <GridSaveInformation current_staff={current_staff} setLoading={setLoading} setIgnoreRefresh={setIgnoreRefresh} />
                                            </Disclosure.Panel>
                                        </Transition>
                                    </div>
                                )}
                            </Disclosure>
                            <br />

                            {(process.env.REACT_APP_COLOUR === "UC" || process.env.REACT_APP_COLOUR === "QL") &&
                                (!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") &&
                                !current_staff.building_manager && (
                                    <>
                                        <Disclosure>
                                            {({ open }) => (
                                                <div className="xl:w-80">
                                                    <Disclosure.Button
                                                        className={`${
                                                            open ? "rounded-t-3xl" : "rounded-3xl"
                                                        } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14 transition duration-100 lineaer`}
                                                    >
                                                        <FontAwesomeIcon icon={faCamera} className="h-5 w-5 text-primary" />
                                                        <h3 className="font-light text-sm text-white">Biometrics</h3>
                                                    </Disclosure.Button>
                                                    <Transition
                                                        enter="transition duration-100 ease-out"
                                                        enterFrom="transform scale-95 opacity-0"
                                                        enterTo="transform scale-100 opacity-100"
                                                        leave="transition duration-75 ease-out"
                                                        leaveFrom="transform scale-100 opacity-100"
                                                        leaveTo="transform scale-95 opacity-0"
                                                    >
                                                        <Disclosure.Panel className="rounded-b-3xl px-4 py-4 bg-gray-100 w-full ease-in duration-300">
                                                            {open && <BiometricsPanel current_booking={current_booking} current_staff={current_staff} />}
                                                        </Disclosure.Panel>
                                                    </Transition>
                                                </div>
                                            )}
                                        </Disclosure>
                                        <br />

                                        {process.env.REACT_APP_COLOUR === "UC" && (
                                            <>
                                                <Disclosure>
                                                    {({ open }) => (
                                                        <div className="xl:w-80">
                                                            <Disclosure.Button
                                                                className={`${
                                                                    open ? "rounded-t-3xl" : "rounded-3xl"
                                                                } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14 transition duration-100 lineaer`}
                                                            >
                                                                <FontAwesomeIcon icon={faBagShopping} className="h-5 w-5 text-primary" />
                                                                <h3 className="font-light text-sm text-white">Pass-Out</h3>
                                                            </Disclosure.Button>
                                                            <Transition
                                                                enter="transition duration-100 ease-out"
                                                                enterFrom="transform scale-95 opacity-0"
                                                                enterTo="transform scale-100 opacity-100"
                                                                leave="transition duration-75 ease-out"
                                                                leaveFrom="transform scale-100 opacity-100"
                                                                leaveTo="transform scale-95 opacity-0"
                                                            >
                                                                <Disclosure.Panel className="rounded-b-3xl px-4 py-4 bg-gray-100 w-full ease-in duration-300">
                                                                    {open && <WeekendPassPanel current_booking={current_booking} current_staff={current_staff} />}
                                                                </Disclosure.Panel>
                                                            </Transition>
                                                        </div>
                                                    )}
                                                </Disclosure>
                                                <br />
                                            </>
                                        )}
                                    </>
                                )}

                            {(process.env.REACT_APP_COLOUR === "UC" || process.env.REACT_APP_COLOUR === "QL") && (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                    onClick={() => checkWifi(current_booking?.property?.wifi_property_id, current_booking?.user?.wifi_account_id, current_booking?.user?.wifi_username)}
                                                >
                                                    <FontAwesomeIcon icon={faWifi} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">WiFi</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                        {current_booking?.property?.wifi_property_id !== null || current_booking?.wi_fi?.length > 0 ? (
                                                            <>
                                                                {current_booking?.wi_fi.length > 0 ? (
                                                                    <>
                                                                        {current_booking?.property?.wifi_property_id !== null && (
                                                                            <>
                                                                                <CustomButton
                                                                                    text="Unlink WIFI"
                                                                                    styling="w-full mb-2"
                                                                                    icon={faPlus}
                                                                                    onClick={() => unlinkWifiAccount(current_booking?.user?.id)}
                                                                                    loading={wiFiLoading ? true : undefined}
                                                                                />
                                                                                <br />
                                                                                <CustomButton
                                                                                    text="Remove WIFI Account"
                                                                                    styling="w-full mb-2"
                                                                                    icon={faTrash}
                                                                                    onClick={() => removeWifiAccount()}
                                                                                    loading={wiFiLoading ? true : undefined}
                                                                                />
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                        <hr />
                                                                        <br />
                                                                        <p>
                                                                            Source: <span className={`font-bold ${current_booking?.wi_fi[0]?.wifi_id ? "text-cyan-600" : "text-orange-600"}`}>{current_booking?.wi_fi[0]?.wifi_id ? "Axio" : "Manual"}</span>
                                                                        </p>
                                                                        {current_booking?.wi_fi[0]?.wifi_id && (
                                                                            <p>
                                                                                Wifi {current_booking?.wi_fi[0]?.mac_address === null ? "Account" : "Device"} ID:{" "}
                                                                                <span className="font-bold">{current_booking?.wi_fi[0]?.wifi_id}</span>
                                                                            </p>
                                                                        )}
                                                                        <br />

                                                                        {current_booking?.wi_fi[0]?.mac_address === null ? (
                                                                            <>
                                                                                <p>
                                                                                    Wifi Username: <span className="font-bold">{current_booking?.wi_fi[0]?.username}</span>
                                                                                </p>
                                                                                <p>
                                                                                    Wifi Password: <span className="font-bold">{current_booking?.wi_fi[0]?.password}</span>
                                                                                </p>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <p>
                                                                                    Wifi Name: <span className="font-bold">{current_booking?.wi_fi[0]?.name}</span>
                                                                                </p>
                                                                                <p>
                                                                                    Wifi Mac Address: <span className="font-bold">{current_booking?.wi_fi[0]?.mac_address}</span>
                                                                                </p>
                                                                            </>
                                                                        )}

                                                                        {current_booking?.wi_fi[0]?.wifi_id ? (
                                                                            <>
                                                                                <br />
                                                                                <p>
                                                                                    Wifi Status: <span className="font-bold">{current_booking?.wi_fi[0]?.status === 0 ? "OFF" : "ON"}</span>
                                                                                </p>
                                                                                <br />
                                                                                {current_booking?.property?.wifi_property_id !== null && (
                                                                                    <CustomButton
                                                                                        text={current_booking?.wi_fi[0]?.status === 0 ? "Switch WiFi On" : "Switch WiFi Off"}
                                                                                        styling="w-full mb-2"
                                                                                        icon={faChartNetwork}
                                                                                        onClick={() =>
                                                                                            switchWiFi(current_booking?.user?.id, current_booking?.wi_fi[0]?.mac_address, current_booking?.wi_fi[0]?.id, 1)
                                                                                        }
                                                                                        loading={wiFiLoading ? true : undefined}
                                                                                    />
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <br />
                                                                        )}

                                                                        {current_booking?.wi_fi.length === 2 ? (
                                                                            <>
                                                                                <br />
                                                                                <hr />
                                                                                <br />

                                                                                <p>
                                                                                    Source: <span className={`font-bold ${current_booking?.wi_fi[1]?.wifi_id ? "text-cyan-600" : "text-orange-600"}`}>{current_booking?.wi_fi[1]?.wifi_id ? "Axio" : "Manual"}</span>
                                                                                </p>
                                                                                {current_booking?.wi_fi[1]?.wifi_id && (
                                                                                    <p>
                                                                                        Wifi {current_booking?.wi_fi[1]?.mac_address === null ? "Account" : "Device"} ID:{" "}
                                                                                        <span className="font-bold">{current_booking?.wi_fi[1]?.wifi_id}</span>
                                                                                    </p>
                                                                                )}
                                                                                <br />

                                                                                {current_booking?.wi_fi[1]?.mac_address === null ? (
                                                                                    <>
                                                                                        <p>
                                                                                            Wifi Username: <span className="font-bold">{current_booking?.wi_fi[1]?.username}</span>
                                                                                        </p>
                                                                                        <p>
                                                                                            Wifi Password: <span className="font-bold">{current_booking?.wi_fi[1]?.password}</span>
                                                                                        </p>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <p>
                                                                                            Wifi Name: <span className="font-bold">{current_booking?.wi_fi[1]?.name}</span>
                                                                                        </p>
                                                                                        <p>
                                                                                            Wifi Mac Address: <span className="font-bold">{current_booking?.wi_fi[1]?.mac_address}</span>
                                                                                        </p>
                                                                                    </>
                                                                                )}

                                                                                {current_booking?.wi_fi[1]?.wifi_id ? (
                                                                                    <>
                                                                                        <br />
                                                                                        <p>
                                                                                            Wifi Status: <span className="font-bold">{current_booking?.wi_fi[1]?.status === 0 ? "OFF" : "ON"}</span>
                                                                                        </p>
                                                                                        <br />
                                                                                        {current_booking?.property?.wifi_property_id !== null && (
                                                                                            <CustomButton
                                                                                                text={current_booking?.wi_fi[1]?.status === 0 ? "Switch WiFi On" : "Switch WiFi Off"}
                                                                                                styling="w-full mb-2"
                                                                                                icon={faChartNetwork}
                                                                                                onClick={() =>
                                                                                                    switchWiFi(current_booking?.user?.id, current_booking?.wi_fi[1]?.mac_address, current_booking?.wi_fi[1]?.id, 2)
                                                                                                }
                                                                                                loading={wiFiLoading2 ? true : undefined}
                                                                                            />
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <br />
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {current_booking?.bed?.wifi !== null && current_booking?.bed?.wifi?.booking_id != current_booking.id && (
                                                                            <CustomButton
                                                                                text="Link WIFI"
                                                                                styling="w-full mb-2"
                                                                                icon={faPlus}
                                                                                onClick={() => linkWifiAccount(current_booking?.user?.id)}
                                                                                loading={wiFiLoading ? true : undefined}
                                                                            />
                                                                        )}

                                                                        <CustomButton
                                                                            text="Create WIFI - If Link Fails"
                                                                            styling="w-full mb-2"
                                                                            icon={faPlus}
                                                                            onClick={() => createWifiAccount(current_booking?.id)}
                                                                            loading={wiFiLoading ? true : undefined}
                                                                        />
                                                                    </>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <p>WiFi not available on {current_booking?.property?.name}</p>
                                                        )}
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                </>
                            )}

                            {(process.env.REACT_APP_COLOUR === "UC" || process.env.REACT_APP_COLOUR === "QL") && (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${
                                                        open ? "rounded-t-3xl" : "rounded-3xl"
                                                    } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14 transition duration-100 lineaer`}
                                                >
                                                    <FontAwesomeIcon icon={faUser} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Queue Plate</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="rounded-b-3xl px-4 pt-4 bg-gray-100 w-full ease-in duration-300">
                                                        <QueuePlate current_staff={current_staff} current_booking={current_booking} properties={properties} />
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                </>
                            )}

                            {process.env.REACT_APP_HIDE_CHAT_TABS == "true" && (
                                <>
                                    <Disclosure defaultOpen={permissions?.includes('shortlisted_default_open') || false}>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                >
                                                    <FontAwesomeIcon icon={faUsersRectangle} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Shortlisted</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                        <GridAOS setIgnoreRefresh={setIgnoreRefresh} isShortlist={true} />
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                    <Disclosure defaultOpen={permissions?.includes('aos_default_open') || false}>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                >
                                                    <FontAwesomeIcon icon={faUsersRectangle} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">AOS</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                        <GridAOS setIgnoreRefresh={setIgnoreRefresh} isShortlisted={false} />
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                </>
                            )}

                            {process.env.REACT_APP_HIDE_CHAT_TABS == "true" && process.env.REACT_APP_COLOUR === "QP" && (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14 transition duration-100 lineaer`}
                                                >
                                                    <FontAwesomeIcon icon={faMapPin} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Lead Sources</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="rounded-b-3xl px-4 py-4 bg-gray-100 w-full ease-in duration-300">
                                                        {open && <GridLeadSources />}
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                </>
                            )}


                            {process.env.REACT_APP_HIDE_CHAT_TABS == "true" && (
                                <>
                                    <Disclosure defaultOpen={permissions?.includes('snagging_default_open') || false}>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14 transition duration-100 lineaer`}
                                                >
                                                    <FontAwesomeIcon icon={faClipboardList} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Snagging</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="rounded-b-3xl px-4 py-4 bg-gray-100 w-full ease-in duration-300">
                                                        <SnagCode />
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                </>
                            )}

                            <Disclosure defaultOpen={current_booking?.bot_flow_id > 0 ? true : false}>
                                {({ open }) => (
                                    <div className="xl:w-80">
                                        <Disclosure.Button className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}>
                                            <FontAwesomeIcon icon={faRobot} className="h-5 w-5 text-primary" />
                                            <h3 className="font-light text-sm text-white">Bot Flow</h3>
                                        </Disclosure.Button>
                                        <Transition
                                            enter="transition duration-100 ease-out"
                                            enterFrom="transform scale-95 opacity-0"
                                            enterTo="transform scale-100 opacity-100"
                                            leave="transition duration-75 ease-out"
                                            leaveFrom="transform scale-100 opacity-100"
                                            leaveTo="transform scale-95 opacity-0"
                                        >
                                            <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                <BookingBotFlow current_staff={current_staff} current_booking={current_booking} />
                                            </Disclosure.Panel>
                                        </Transition>
                                    </div>
                                )}
                            </Disclosure>
                            <br />

                            {type != "collections" ? (
                                <>
                                    <Disclosure defaultOpen={permissions?.includes('bookings_default_open') || false}>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                >
                                                    <FontAwesomeIcon icon={faUsersRectangle} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Bookings</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                        <GridBookingInformation bookingGridCallback={handleHistoricBookingsCallback} />
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />

                                    {(!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") && (
                                        <>
                                            {!current_staff.building_manager ? (
                                                <>
                                                    {/* Invoice and Lease - Always visible (unit/bed assignment lives here) */}
                                                    <Disclosure>
                                                        {({ open }) => (
                                                            <div className="xl:w-80">
                                                                <Disclosure.Button
                                                                    className={`${
                                                                        open ? "rounded-t-3xl" : "rounded-3xl"
                                                                    } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                                >
                                                                    <FontAwesomeIcon icon={faFilePen} className="h-5 w-5 text-primary" />
                                                                    <h3 className="font-light text-sm text-white">Invoice and Lease</h3>
                                                                </Disclosure.Button>
                                                                <Transition
                                                                    enter="transition duration-100 ease-out"
                                                                    enterFrom="transform scale-95 opacity-0"
                                                                    enterTo="transform scale-100 opacity-100"
                                                                    leave="transition duration-75 ease-out"
                                                                    leaveFrom="transform scale-100 opacity-100"
                                                                    leaveTo="transform scale-95 opacity-0"
                                                                >
                                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                                        <GridInvoiceInformation setIgnoreRefresh={setIgnoreRefresh} />
                                                                    </Disclosure.Panel>
                                                                </Transition>
                                                            </div>
                                                        )}
                                                    </Disclosure>
                                                    <br />
                                                    {/* Additional Invoices - Hidden for Tenant-Only */}
                                                    {!isTenantOnly() && (
                                                    <>
                                                    <Disclosure>
                                                        {({ open }) => (
                                                            <div className="xl:w-80">
                                                                <Disclosure.Button
                                                                    className={`${
                                                                        open ? "rounded-t-3xl" : "rounded-3xl"
                                                                    } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                                >
                                                                    <FontAwesomeIcon icon={faFileInvoice} className="h-5 w-5 text-primary" />
                                                                    <h3 className="font-light text-sm text-white">Additional Invoices</h3>
                                                                </Disclosure.Button>
                                                                <Transition
                                                                    enter="transition duration-100 ease-out"
                                                                    enterFrom="transform scale-95 opacity-0"
                                                                    enterTo="transform scale-100 opacity-100"
                                                                    leave="transition duration-75 ease-out"
                                                                    leaveFrom="transform scale-100 opacity-100"
                                                                    leaveTo="transform scale-95 opacity-0"
                                                                >
                                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                                        <GridAdditionalInvoice />
                                                                    </Disclosure.Panel>
                                                                </Transition>
                                                            </div>
                                                        )}
                                                    </Disclosure>
                                                    <br />
                                                    </>
                                                    )}
                                                    {/* Cancellations and Renewals - Hidden for Tenant-Only */}
                                                    {!isTenantOnly() && (
                                                        <>
                                                            <div className="xl:w-80">
                                                                <button
                                                                    onClick={() => setShowCancellationsModal(true)}
                                                                    className="rounded-3xl w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14 hover:bg-opacity-90 transition"
                                                                >
                                                                    <FontAwesomeIcon icon={faPersonWalkingDashedLineArrowRight} className="h-5 w-5 text-primary" />
                                                                    <h3 className="font-light text-sm text-white">Cancellations and Renewals</h3>
                                                                </button>
                                                            </div>
                                                            <br />
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                ""
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${
                                                        open ? "rounded-t-3xl" : "rounded-3xl"
                                                    } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14 transition duration-100 lineaer`}
                                                >
                                                    <FontAwesomeIcon icon={faGear} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Settings</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="rounded-b-3xl px-4 py-4 bg-gray-100 w-full ease-in duration-300">
                                                        <GridSettings />
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>

                                    {(!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") && (
                                        <>
                                            <br />
                                            <Disclosure>
                                                {({ open }) => (
                                                    <div className="xl:w-80">
                                                        <Disclosure.Button
                                                            className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                        >
                                                            <FontAwesomeIcon icon={faFingerprint} className="h-5 w-5 text-primary" />
                                                            <h3 className="font-light text-sm text-white">Biometrics Access</h3>
                                                        </Disclosure.Button>
                                                        <Transition
                                                            enter="transition duration-100 ease-out"
                                                            enterFrom="transform scale-95 opacity-0"
                                                            enterTo="transform scale-100 opacity-100"
                                                            leave="transition duration-75 ease-out"
                                                            leaveFrom="transform scale-100 opacity-100"
                                                            leaveTo="transform scale-95 opacity-0"
                                                        >
                                                            <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                                {/* {process.env.REACT_APP_COLOUR === "UC" ? <GridBiometrics /> : ""} */}
                                                                <GridBiometrics current_staff={current_staff} current_booking={current_booking} />
                                                            </Disclosure.Panel>
                                                        </Transition>
                                                    </div>
                                                )}
                                            </Disclosure>
                                        </>
                                    )}

                                    <br />
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                >
                                                    <FontAwesomeIcon icon={faHandHoldingDollar} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">POP's</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                        <div className="h-60 overflow-y-scroll scroll-smooth">
                                                            {current_booking?.files && current_booking?.files.length > 0 ? (
                                                                <>
                                                                    {current_booking?.files.map((file) => (
                                                                        <>
                                                                            {file.file_type == "POP" ? (
                                                                                <>
                                                                                    <div
                                                                                        className="border-2 w-full rounded px-1 py-1 my-2 cursor-pointer hover:-translate-y-0.5 hover:bg-dark_background hover:text-white"
                                                                                        onClick={() =>
                                                                                            dispatch(
                                                                                                openModal({
                                                                                                    modal_type: "ModalViewFiles",
                                                                                                    modal_props: {
                                                                                                        files: [
                                                                                                            {
                                                                                                                id: file.id,
                                                                                                            },
                                                                                                        ],
                                                                                                    },
                                                                                                }),
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <p className="text-center">{file.name}</p>
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </>
                                                                    ))}
                                                                </>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                </>
                            )}

                            {(!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") && (
                                <>
                                    {!current_staff.building_manager ? (
                                        <>
                                        <Disclosure>
                                            {({ open }) => (
                                                <div className="xl:w-80">
                                                    <Disclosure.Button
                                                        className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                    >
                                                        <FontAwesomeIcon icon={faCreditCard} className="h-5 w-5 text-primary" />
                                                        <h3 className="font-light text-sm text-white"> {type != "collections" ? "Credit Check" : "BlackList / TPN"}</h3>
                                                    </Disclosure.Button>
                                                    <Transition
                                                        enter="transition duration-100 ease-out"
                                                        enterFrom="transform scale-95 opacity-0"
                                                        enterTo="transform scale-100 opacity-100"
                                                        leave="transition duration-75 ease-out"
                                                        leaveFrom="transform scale-100 opacity-100"
                                                        leaveTo="transform scale-95 opacity-0"
                                                    >
                                                        <Disclosure.Panel className="rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                            <CreditCheck current_booking={current_booking} current_staff={current_staff} />
                                                        </Disclosure.Panel>
                                                    </Transition>
                                                </div>
                                            )}
                                        </Disclosure>
                                            <br />
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </>
                            )}

                            {(!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") && !isTenantOnly() && (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                >
                                                    <FontAwesomeIcon icon={faPersonWalkingDashedLineArrowRight} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">MDA</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                        <GridBookingMda current_booking={current_booking} current_staff={current_staff} />
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                </>
                            )}

                            {type != "collections" ? (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                >
                                                    <FontAwesomeIcon icon={faCalendarCheck} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Appointments</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                        <GridBookingAppointments />
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>

                                    {!current_staff.building_manager && !isTenantOnly() && (
                                        <>
                                            <br />
                                            <Disclosure>
                                                {({ open }) => (
                                                    <div className="xl:w-80">
                                                        <Disclosure.Button
                                                            className={`${
                                                                open ? "rounded-t-3xl" : "rounded-3xl"
                                                            } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                        >
                                                            <FontAwesomeIcon icon={faUsersRectangle} className="h-5 w-5 text-primary" />
                                                            <h3 className="font-light text-sm text-white">Payments</h3>
                                                        </Disclosure.Button>
                                                        <Transition
                                                            enter="transition duration-100 ease-out"
                                                            enterFrom="transform scale-95 opacity-0"
                                                            enterTo="transform scale-100 opacity-100"
                                                            leave="transition duration-75 ease-out"
                                                            leaveFrom="transform scale-100 opacity-100"
                                                            leaveTo="transform scale-95 opacity-0"
                                                        >
                                                            <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                                <GridPayments />
                                                            </Disclosure.Panel>
                                                        </Transition>
                                                    </div>
                                                )}
                                            </Disclosure>
                                        </>
                                    )}

                                    <br />
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                >
                                                    <FontAwesomeIcon icon={faHousePersonReturn} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Move In / Out</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">{open && <GridMoveIn />}</Disclosure.Panel>
                                                </Transition>
                                                <br />
                                            </div>
                                        )}
                                    </Disclosure>
                                </>
                            ) : (
                                ""
                            )}

                            {(process.env.REACT_APP_COLOUR === "UC" || process.env.REACT_APP_COLOUR === "QL") && (current_staff.id == "291" || current_staff.id == "1") ? (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                >
                                                    <FontAwesomeIcon icon={faListCheck} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">@'s</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                        <AtInfo />
                                                    </Disclosure.Panel>
                                                </Transition>
                                            </div>
                                        )}
                                    </Disclosure>
                                    <br />
                                </>
                            ) : (
                                ""
                            )}

                            {false && (!process.env.REACT_APP_HIDE_CHAT_TABS || process.env.REACT_APP_HIDE_CHAT_TABS === "false") && (
                                <>
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className="xl:w-80">
                                                <Disclosure.Button
                                                    className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                >
                                                    <FontAwesomeIcon icon={faBagShopping} className="h-5 w-5 text-primary" />
                                                    <h3 className="font-light text-sm text-white">Orders</h3>
                                                </Disclosure.Button>
                                                <Transition
                                                    enter="transition duration-100 ease-out"
                                                    enterFrom="transform scale-95 opacity-0"
                                                    enterTo="transform scale-100 opacity-100"
                                                    leave="transition duration-75 ease-out"
                                                    leaveFrom="transform scale-100 opacity-100"
                                                    leaveTo="transform scale-95 opacity-0"
                                                >
                                                    <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                        <CustomOrders />
                                                    </Disclosure.Panel>
                                                </Transition>
                                                <br />
                                            </div>
                                        )}
                                    </Disclosure>
                                </>
                            )}

                            {/* Duplicate QL WiFi tab removed - the WiFi tab above (UC || QL) already covers QL */}

                            {process.env.REACT_APP_COLOUR !== "QL" && current_booking.location === "Residents" && type !== "collections" && current_staff.restrict_views === 0 ? (
                                <>
                                    <Link to={"/booking/collections?collection_tag=-1&user_id=" + current_booking?.user.id + "&booking_id=" + current_booking.id + (property_id ? "&property_id=" + property_id : "")}>
                                        <Disclosure>
                                            {({ open }) => (
                                                <div className="xl:w-80">
                                                    <Disclosure.Button
                                                        className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                    >
                                                        <FontAwesomeIcon icon={faRectangleHistory} className="h-5 w-5 text-primary" />
                                                        <h3 className="font-light text-sm text-white">Collections</h3>
                                                    </Disclosure.Button>
                                                </div>
                                            )}
                                        </Disclosure>
                                        <br />
                                    </Link>
                                </>
                            ) : (
                                <>
                                    {process.env.REACT_APP_COLOUR !== "QL" && current_booking.location === "Residents" && type === "collections" && current_staff.restrict_views === 0 ? (
                                        <>
                                            <br />
                                            <Link to={"/booking/management?tag=" + current_booking.tag + "&user_id=" + current_booking?.user.id + "&booking_id=" + current_booking.id + (property_id ? "&property_id=" + property_id : "")}>
                                                <Disclosure>
                                                    {({ open }) => (
                                                        <div className="xl:w-80">
                                                            <Disclosure.Button
                                                                className={`${
                                                                    open ? "rounded-t-3xl" : "rounded-3xl"
                                                                } w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                                            >
                                                                <FontAwesomeIcon icon={faRectangleHistory} className="h-5 w-5 text-primary" />
                                                                <h3 className="font-light text-sm text-white">Management</h3>
                                                            </Disclosure.Button>
                                                        </div>
                                                    )}
                                                </Disclosure>
                                            </Link>
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </>
                            )}

                            <Disclosure>
                                {({ open }) => (
                                    <div className="xl:w-80">
                                        <Disclosure.Button className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}>
                                            <FontAwesomeIcon icon={faFilePen} className="h-5 w-5 text-primary" />
                                            <h3 className="font-light text-sm text-white">Documents</h3>
                                        </Disclosure.Button>
                                        <Transition
                                            enter="transition duration-100 ease-out"
                                            enterFrom="transform scale-95 opacity-0"
                                            enterTo="transform scale-100 opacity-100"
                                            leave="transition duration-75 ease-out"
                                            leaveFrom="transform scale-100 opacity-100"
                                            leaveTo="transform scale-95 opacity-0"
                                        >
                                            <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                <GridDocumentGeneration current_booking={current_booking} current_staff={current_staff} />
                                            </Disclosure.Panel>
                                        </Transition>
                                        <br />
                                    </div>
                                )}
                            </Disclosure>


                            {/* Custom Data - hidden behind the same flag as Dev Stuff (show_dev_stuff) */}
                            {current_staff && !!current_staff.show_dev_stuff && (
                            <Disclosure>
                                {({ open }) => (
                                    <div className="xl:w-80">
                                        <Disclosure.Button
                                            className={`${open ? "rounded-t-3xl" : "rounded-3xl"} w-full py-3 pr-4 flex space-x-4 justify-center items-center bg-dark_background h-14`}
                                            onClick={async () => {
                                                if (!open && customData.length === 0) {
                                                    await fetchCustomData();
                                                }
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faClipboardList} className="h-5 w-5 text-primary" />
                                            <h3 className="font-light text-sm text-white">Custom Data</h3>
                                        </Disclosure.Button>
                                        <Transition
                                            enter="transition duration-100 ease-out"
                                            enterFrom="transform scale-95 opacity-0"
                                            enterTo="transform scale-100 opacity-100"
                                            leave="transition duration-75 ease-out"
                                            leaveFrom="transform scale-100 opacity-100"
                                            leaveTo="transform scale-95 opacity-0"
                                        >
                                            <Disclosure.Panel className="h-full rounded-b-3xl px-4 py-4 bg-gray-100 w-full">
                                                {/* Toolbar */}
                                                <div className="mb-3 space-y-2">
                                                    <div className="grid grid-cols-2 gap-2">
                                                        <button
                                                            type="button"
                                                            className="w-full py-2 rounded-md bg-white border border-primary text-primary hover:bg-primary hover:text-white transition disabled:opacity-60"
                                                            onClick={fetchCustomData}
                                                            disabled={customDataLoading}
                                                        >
                                                            {customDataLoading ? (
                                                                <span className="inline-flex items-center space-x-2">
                                                                    <FontAwesomeIcon icon={faSpinnerThird} spin className="h-4 w-4" />
                                                                    <span>Refreshing…</span>
                                                                </span>
                                                            ) : (
                                                                <span>Refresh</span>
                                                            )}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="w-full py-2 rounded-md bg-primary text-white hover:opacity-90 transition"
                                                            onClick={() => setShowAddForm((v) => !v)}
                                                        >
                                                            {showAddForm ? "Close" : "Add"}
                                                        </button>
                                                    </div>

                                                    <input
                                                        type="text"
                                                        value={customSearch}
                                                        onChange={(e) => setCustomSearch(e.target.value)}
                                                        placeholder="Search key/value"
                                                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary bg-white"
                                                    />
                                                </div>

                                                {/* Add new custom data */}
                                                {showAddForm && (
                                                    <div className="mb-4 p-3 bg-white border border-gray-200 rounded-lg">
                                                        <div className="text-sm font-medium text-gray-700 mb-2">Add Custom Data</div>
                                                        <div className="grid grid-cols-1 gap-2">
                                                            <input
                                                                type="text"
                                                                value={newCustomKey}
                                                                onChange={(e) => setNewCustomKey(e.target.value)}
                                                                placeholder="Key (e.g., raa_override, raa_payment_type)"
                                                                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                                                            />
                                                            <input
                                                                type="text"
                                                                value={newCustomValue}
                                                                onChange={(e) => setNewCustomValue(e.target.value)}
                                                                placeholder={
                                                                    newCustomKey === "raa_override"
                                                                        ? "Value (e.g., 6000 for R6000 deposit)"
                                                                        : newCustomKey === "raa_payment_type"
                                                                        ? "Value (Monthly, Part, or One)"
                                                                        : "Value"
                                                                }
                                                                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                                                            />
                                                            {newCustomKey === "raa_override" && (
                                                                <div className="text-xs text-gray-600 bg-blue-50 border border-blue-200 rounded p-2">
                                                                    <strong>RAA Override:</strong> Enter base deposit amount in rands (numeric only).
                                                                    <br />
                                                                    Example: 6000 = Monthly R600, Part R3000, One R6000
                                                                </div>
                                                            )}
                                                            {newCustomKey === "raa_payment_type" && (
                                                                <div className="text-xs text-gray-600 bg-blue-50 border border-blue-200 rounded p-2">
                                                                    <strong>RAA Payment Type:</strong> Student's payment choice.
                                                                    <br />
                                                                    Options: <strong>Monthly</strong>, <strong>Part</strong>, or <strong>One</strong>
                                                                </div>
                                                            )}
                                                            <button
                                                                type="button"
                                                                className="w-full py-2 rounded-md bg-primary text-white hover:opacity-90 transition disabled:opacity-60"
                                                                disabled={customSubmitting || !newCustomKey}
                                                                onClick={async () => {
                                                                    if (!current_booking?.id) {
                                                                        toast(<NotificationToast title="No booking" message="Active booking not found." type="error" />);
                                                                        return;
                                                                    }
                                                                    setCustomSubmitting(true);
                                                                    try {
                                                                        await axios.post(`${process.env.REACT_APP_API_URL}user/${current_booking.user.id}/custom-data`, {
                                                                            booking_id: current_booking.id,
                                                                            key: newCustomKey,
                                                                            value: newCustomValue,
                                                                        });
                                                                        setNewCustomKey("");
                                                                        setNewCustomValue("");
                                                                        setShowAddForm(false);
                                                                        await fetchCustomData();
                                                                    } catch (e) {
                                                                        toast(
                                                                            <NotificationToast
                                                                                title="Failed to add Custom Data"
                                                                                message={e?.response?.data?.message || e?.message || "Unknown error"}
                                                                                type="error"
                                                                            />,
                                                                        );
                                                                    } finally {
                                                                        setCustomSubmitting(false);
                                                                    }
                                                                }}
                                                            >
                                                                {customSubmitting ? "Adding…" : "Add"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                                {customDataLoading ? (
                                                    <div className="flex items-center space-x-2 text-gray-600">
                                                        <FontAwesomeIcon icon={faSpinnerThird} spin className="h-4 w-4" />
                                                        <span>Loading...</span>
                                                    </div>
                                                ) : (
                                                    <div className="h-60 overflow-y-auto">
                                                        {customData.length === 0 ? (
                                                            <p className="text-sm text-gray-600">No custom data entries found.</p>
                                                        ) : (
                                                            <div className="grid grid-cols-1 gap-3">
                                                                {customData
                                                                    .filter((row) => {
                                                                        const q = customSearch.trim().toLowerCase();
                                                                        if (!q) return true;
                                                                        return (
                                                                            (row.key || "").toLowerCase().includes(q) ||
                                                                            String(row.value || "")
                                                                                .toLowerCase()
                                                                                .includes(q) ||
                                                                            (row.year ? String(row.year) : "").toLowerCase().includes(q)
                                                                        );
                                                                    })
                                                                    .map((row) => (
                                                                        <div key={`${row.id}`} className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm">
                                                                            <div className="flex items-start justify-between">
                                                                                <div className="text-xs uppercase tracking-wide text-gray-500">{row.year ? `Year ${row.year}` : "Year -"}</div>
                                                                                <div className="text-xs text-gray-500">Booking #{row.booking_id}</div>
                                                                            </div>
                                                                            {editingCustomId === row.id ? (
                                                                                <div className="mt-2 space-y-2">
                                                                                    <input
                                                                                        type="text"
                                                                                        value={editCustomKey}
                                                                                        onChange={(e) => setEditCustomKey(e.target.value)}
                                                                                        placeholder="Key"
                                                                                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                                                                                    />
                                                                                    <textarea
                                                                                        value={editCustomValue}
                                                                                        onChange={(e) => setEditCustomValue(e.target.value)}
                                                                                        placeholder="Value"
                                                                                        rows={3}
                                                                                        className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                                                                                    />
                                                                                    <div className="flex space-x-2">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="flex-1 py-2 rounded-md bg-primary text-white hover:opacity-90 transition disabled:opacity-60 text-xs"
                                                                                            disabled={editCustomSubmitting || !editCustomKey}
                                                                                            onClick={async () => {
                                                                                                setEditCustomSubmitting(true);
                                                                                                try {
                                                                                                    await axios.put(`${process.env.REACT_APP_API_URL}user/custom-data/${row.id}`, {
                                                                                                        key: editCustomKey,
                                                                                                        value: editCustomValue,
                                                                                                    });
                                                                                                    setEditingCustomId(null);
                                                                                                    await fetchCustomData();
                                                                                                } catch (e) {
                                                                                                    toast(
                                                                                                        <NotificationToast
                                                                                                            title="Update failed"
                                                                                                            message={e?.response?.data?.message || e?.message || "Unknown error"}
                                                                                                            type="error"
                                                                                                        />,
                                                                                                    );
                                                                                                } finally {
                                                                                                    setEditCustomSubmitting(false);
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            {editCustomSubmitting ? "Saving…" : "Save"}
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="flex-1 py-2 rounded-md bg-gray-200 text-gray-700 hover:bg-gray-300 transition text-xs"
                                                                                            onClick={() => setEditingCustomId(null)}
                                                                                        >
                                                                                            Cancel
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <div className="mt-2">
                                                                                    <div className="text-gray-800 text-sm font-semibold break-words">{row.key}</div>
                                                                                    <div className="mt-1 text-gray-700 text-sm break-words whitespace-pre-wrap">{String(row.value)}</div>
                                                                                </div>
                                                                            )}
                                                                            <div className="mt-3 text-xs text-gray-500 flex items-center justify-between">
                                                                                <span>{row.updated_at ? moment(row.updated_at).format("DD MMM YYYY HH:mm") : ""}</span>
                                                                                {current_staff?.isSuper === 1 && editingCustomId !== row.id && (
                                                                                    <div className="flex space-x-3">
                                                                                        <button
                                                                                            type="button"
                                                                                            className="text-primary hover:text-primary/80 text-xs"
                                                                                            title="Edit"
                                                                                            onClick={() => {
                                                                                                setEditingCustomId(row.id);
                                                                                                setEditCustomKey(row.key || "");
                                                                                                setEditCustomValue(String(row.value || ""));
                                                                                            }}
                                                                                        >
                                                                                            Edit
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="text-red-600 hover:text-red-700 text-xs"
                                                                                            title="Delete"
                                                                                            onClick={async () => {
                                                                                                if (!window.confirm("Are you sure you want to delete this custom data?")) return;
                                                                                                try {
                                                                                                    await axios.delete(`${process.env.REACT_APP_API_URL}user/custom-data/${row.id}`);
                                                                                                    await fetchCustomData();
                                                                                                } catch (e) {
                                                                                                    toast(
                                                                                                        <NotificationToast
                                                                                                            title="Delete failed"
                                                                                                            message={e?.response?.data?.message || e?.message || "Unknown error"}
                                                                                                            type="error"
                                                                                                        />,
                                                                                                    );
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            Delete
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </Disclosure.Panel>
                                        </Transition>
                                        <br />
                                    </div>
                                )}
                            </Disclosure>
                            )}
                        </>
                    )}
                </div>
            </div>
            </>
        </>
    );
}
